import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as XLSX from "xlsx";

declare var ko: any;

const PAYGRADE_MAP: Record<string, number> = {
	"O-10": 1,
	"O-9": 2,
	"O-8": 3,
	"O-7": 4,
	"O-6": 5,
	"O-5": 6,
	"O-4": 7,
	"O-3": 8,
	"O-2": 9,
	"O-1": 10,
	"O-3E": 11,
	"O-2E": 12,
	"O-1E": 13,
	"W-5": 14,
	"W-4": 15,
	"W-3": 16,
	"W-2": 17,
	"W-1": 18,
	"E-9": 19,
	"E-8": 20,
	"E-7": 21,
	"E-6": 22,
	"E-5": 23,
	"E-4": 24,
	"E-3": 25,
	"E-2": 26,
	"E-1": 27,
};

(function () {
	const aliases: Array<[string, string]> = [
		["O10", "O-10"],
		["O9", "O-9"],
		["O8", "O-8"],
		["O7", "O-7"],
		["O6", "O-6"],
		["O5", "O-5"],
		["O4", "O-4"],
		["O3", "O-3"],
		["O2", "O-2"],
		["O1", "O-1"],
		["O3E", "O-3E"],
		["O2E", "O-2E"],
		["O1E", "O-1E"],
		["W5", "W-5"],
		["W4", "W-4"],
		["W3", "W-3"],
		["W2", "W-2"],
		["W1", "W-1"],
		["E9", "E-9"],
		["E8", "E-8"],
		["E7", "E-7"],
		["E6", "E-6"],
		["E5", "E-5"],
		["E4", "E-4"],
		["E3", "E-3"],
		["E2", "E-2"],
		["E1", "E-1"],
	];
	for (const [alias, canonical] of aliases) {
		PAYGRADE_MAP[alias] = PAYGRADE_MAP[canonical];
	}
})();

const BAH_COL_TO_PAYGRADE: Record<string, number> = {
	E01: 27,
	E02: 26,
	E03: 25,
	E04: 24,
	E05: 23,
	E06: 22,
	E07: 21,
	E08: 20,
	E09: 19,
	W01: 18,
	W02: 17,
	W03: 16,
	W04: 15,
	W05: 14,
	O01E: 13,
	O02E: 12,
	O03E: 11,
	O01: 10,
	O02: 9,
	O03: 8,
	O04: 7,
	O05: 6,
	O06: 5,
	O07: 4,
	O08: 3,
	O09: 2,
	O10: 1,
};

/** Normalize Excel header to BAH column key (E01, O10, etc.) for column-by-name lookup. */
const BAH_HEADER_TO_COL_KEY: Record<string, string> = {};
(function () {
	const pairs: [string, string][] = [
		["E-1", "E01"],
		["E-2", "E02"],
		["E-3", "E03"],
		["E-4", "E04"],
		["E-5", "E05"],
		["E-6", "E06"],
		["E-7", "E07"],
		["E-8", "E08"],
		["E-9", "E09"],
		["W-1", "W01"],
		["W-2", "W02"],
		["W-3", "W03"],
		["W-4", "W04"],
		["W-5", "W05"],
		["O-1E", "O01E"],
		["O-2E", "O02E"],
		["O-3E", "O03E"],
		["O-1", "O01"],
		["O-2", "O02"],
		["O-3", "O03"],
		["O-4", "O04"],
		["O-5", "O05"],
		["O-6", "O06"],
		["O-7", "O07"],
		["O-8", "O08"],
		["O-9", "O09"],
		["O-10", "O10"],
	];
	for (const [label, key] of pairs) {
		BAH_HEADER_TO_COL_KEY[label] = key;
		BAH_HEADER_TO_COL_KEY[label.replace("-", "")] = key; // O10, E1, etc.
	}
})();

const COLA_COL_INDICES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 18, 20];

const PAYGRADE_NAMES = ["E-1", "E-2", "E-3", "E-4", "E-5", "E-6", "E-7", "E-8", "E-9", "W-1", "W-2", "W-3", "W-4", "W-5", "O-1E", "O-2E", "O-3E", "O-1", "O-2", "O-3", "O-4", "O-5", "O-6", "O-7", "O-8", "O-9", "O-10"];

const COLA_PAYGRADE_ORDER = [
	"O-10",
	"O-9",
	"O-8",
	"O-7",
	"O-6",
	"O-5",
	"O-4",
	"O-3",
	"O-2",
	"O-1",
	"O-3E",
	"O-2E",
	"O-1E",
	"W-5",
	"W-4",
	"W-3",
	"W-2",
	"W-1",
	"E-9",
	"E-8",
	"E-7",
	"E-6",
	"E-5",
	"E-4",
	"E-3",
	"E-2",
	"E-1",
];

function makeNameValueList(entries: Array<[number | string, string]>): Array<{ value: number | string; name: string }> {
	return entries.map(([value, name]) => ({ value, name }));
}

const BASIC_PAY_STATUS_OPTIONS = makeNameValueList([
	[3, "Active Duty"],
	[1, "National Guard"],
	[2, "Reservist"],
]);

const DEPENDANTS_OPTIONS = makeNameValueList([
	[2, "Yes"],
	[1, "No"],
]);

const BRANCH_OPTIONS = makeNameValueList([
	[3, "Army"],
	[1, "Marine Corps"],
	[4, "Navy"],
	[2, "Air Force"],
	[5, "Coast Guard"],
]);

/** Sea Pay Matrix: branch ID (key in payload) to API branch name used in row.branch */
const SEAPAY_BRANCH_ID_TO_API_NAME: Record<string, string> = {
	"1": "MARINE_CORPS",
	"2": "AIR_FORCE",
	"3": "ARMY",
	"4": "NAVY",
	"5": "COAST_GUARD",
};
const SEAPAY_BRANCH_IDS = ["1", "2", "3", "4", "5"];
const BRANCH_API_NAME_TO_ID: Record<string, string> = {};
for (const id of SEAPAY_BRANCH_IDS) {
	BRANCH_API_NAME_TO_ID[SEAPAY_BRANCH_ID_TO_API_NAME[id]] = id;
}

const YEARS_OF_SERVICE_OPTIONS = makeNameValueList([
	[1, "2 or less"],
	[2, "Over 2"],
	[3, "Over 3"],
	[4, "Over 4"],
	[5, "Over 6"],
	[6, "Over 8"],
	[7, "Over 10"],
	[8, "Over 12"],
	[9, "Over 14"],
	[10, "Over 16"],
	[11, "Over 18"],
	[12, "Over 20"],
	[13, "Over 22"],
	[14, "Over 24"],
	[15, "Over 26"],
	[16, "Over 30"],
	[17, "Over 34"],
	[18, "Over 38"],
]);

const YEARS_OF_SEA_DUTY_OPTIONS = makeNameValueList([
	[1, "1 or less"],
	[2, "Over 1"],
	[3, "Over 2"],
	[4, "Over 3"],
	[5, "Over 4"],
	[6, "Over 5"],
	[7, "Over 6"],
	[8, "Over 7"],
	[9, "Over 8"],
	[10, "Over 9"],
	[11, "Over 10"],
	[12, "Over 11"],
	[13, "Over 12"],
	[14, "Over 13"],
	[15, "Over 14"],
	[16, "Over 16"],
	[17, "Over 18"],
	[18, "Over 20"],
]);

/** Sea Pay Matrix: years dropdown with N/A for null */
const YEARS_OF_SEA_DUTY_OPTIONS_WITH_NULL = [{ value: null as number | null, name: "N/A" }, ...YEARS_OF_SEA_DUTY_OPTIONS];

const YEARS_OF_SUBMARINE_EXPERIENCE_OPTIONS = makeNameValueList([
	[1, "2 or less"],
	[2, "Over 2"],
	[3, "Over 3"],
	[4, "Over 4"],
	[5, "Over 6"],
	[6, "Over 8"],
	[7, "Over 10"],
	[8, "Over 14"],
	[9, "Over 16"],
	[10, "Over 18"],
]);

const YEARS_OF_SUBMARINE_EXPERIENCE_OPTIONS_WITH_NULL = [{ value: null as number | null, name: "N/A" }, ...YEARS_OF_SUBMARINE_EXPERIENCE_OPTIONS];

const YEARS_OF_HAZARDOUS_DUTY_AWACS_OPTIONS = makeNameValueList([
	[1, "2 or Less Years"],
	[2, "Over 2 Years"],
	[3, "Over 3 Years"],
	[4, "Over 4 Years"],
	[5, "Over 6 Years"],
	[6, "Over 8 Years"],
	[7, "Over 10 Years"],
	[8, "Over 12 Years"],
	[9, "Over 14 Years"],
	[10, "Over 16 Years"],
	[11, "Over 18 Years"],
	[12, "Over 20 Years"],
	[13, "Over 22 Years"],
	[14, "Over 24 Years"],
	[15, "Over 25 Years"],
]);

const AIR_FORCE_ENLISTED_FLYERS_OPTIONS = makeNameValueList([
	[1, "4 or Less Years"],
	[2, "Over 4 Years"],
	[3, "Over 8 Years"],
	[4, "Over 14 Years"],
]);

const NAVY_ENLISTED_FLYERS_OPTIONS = makeNameValueList([
	[1, "4 or Less Years"],
	[2, "Over 4 Years"],
	[3, "Over 8 Years"],
	[4, "Over 14 Years"],
]);

const YEARS_OF_SPECIAL_MISSIONS_OPTIONS = makeNameValueList([
	[1, "Less than 3 years"],
	[2, "More than 3 years"],
]);

const PAYGRADE_OPTIONS = PAYGRADE_NAMES.map((name) => ({ value: PAYGRADE_MAP[name], name }));

const YEARS_OF_AVIATION_EXPERIENCE_DEFAULTS = [
	{ label: "2 or Less Years", value: 125 },
	{ label: "Over 2 Years", value: 156 },
	{ label: "Over 3 Years", value: 188 },
	{ label: "Over 4 Years", value: 206 },
	{ label: "Over 6 Years", value: 650 },
	{ label: "Over 14 Years", value: 840 },
	{ label: "Over 22 Years", value: 585 },
	{ label: "Over 23 Years", value: 495 },
	{ label: "Over 24 Years", value: 385 },
	{ label: "Over 25 Years", value: 250 },
];

const YEARS_OF_AIR_FORCE_AVIATION_EXPERIENCE_DEFAULTS = [
	{ label: "2 or Less Years", value: 150 },
	{ label: "Over 2 Years", value: 250 },
	{ label: "Over 6 Years", value: 700 },
	{ label: "Over 12 Years", value: 1000 },
	{ label: "Over 22 Years", value: 700 },
	{ label: "Over 24 Years", value: 450 },
];

const AIR_FORCE_ENLISTED_PAY_DEFAULTS = {
	"1": 225,
	"2": 350,
	"3": 500,
	"4": 600,
};

const NAVY_ENLISTED_PAY_DEFAULTS = {
	"1": 150,
	"2": 225,
	"3": 350,
	"4": 400,
};

const HDIP_CREW_MEMBER_DEFAULTS: Record<number, number> = {
	1: 150,
	2: 150,
	3: 150,
	4: 150,
	5: 250,
	6: 250,
	7: 225,
	8: 175,
	9: 150,
	10: 150,
	11: 0,
	12: 0,
	13: 0,
	14: 250,
	15: 250,
	16: 175,
	17: 150,
	18: 150,
	19: 240,
	20: 240,
	21: 240,
	22: 215,
	23: 190,
	24: 165,
	25: 150,
	26: 150,
	27: 150,
};

export class militaryPayCalculator_template extends vnTemplate {
	protected getTemplateHtml(): string {
		return /*html*/ `
        <div class="milpay-calculator">
            <div class="form-header">
                <h2>Military Pay Calculator Builder</h2>
                <span data-bind="text: statusText" class="milpay-status-text"></span>
            </div>

            <!-- Tab Navigation -->
            <div class="milpay-tabs">
                <button data-bind="click: function(){ $data.activeTab('uploads'); }, css: {'milpay-tab-active': activeTab() === 'uploads'}" class="milpay-tab">File Uploads</button>
                <button data-bind="click: function(){ $data.activeTab('general'); }, css: {'milpay-tab-active': activeTab() === 'general'}" class="milpay-tab">General Settings</button>
                <button data-bind="click: function(){ $data.activeTab('special'); }, css: {'milpay-tab-active': activeTab() === 'special'}" class="milpay-tab">Special Pay</button>
                <button data-bind="click: function(){ $data.activeTab('diving'); }, css: {'milpay-tab-active': activeTab() === 'diving'}" class="milpay-tab">Diving & EOD</button>
                <button data-bind="click: function(){ $data.activeTab('aviation'); }, css: {'milpay-tab-active': activeTab() === 'aviation'}" class="milpay-tab">Aviation Pay</button>
                <button data-bind="click: function(){ $data.activeTab('summary'); }, css: {'milpay-tab-active': activeTab() === 'summary'}" class="milpay-tab">Summary</button>
                <button data-bind="click: function(){ $data.activeTab('generate'); }, css: {'milpay-tab-active': activeTab() === 'generate'}" class="milpay-tab">Generate JSON</button>
            </div>

            <div class="form-body">

                <!-- ==================== FILE UPLOADS TAB ==================== -->
                <div data-bind="visible: activeTab() === 'uploads'">
                    <h3 style="margin-top:0;">Data File Uploads</h3>
                    <p style="color:#6c757d;margin-bottom:1.5rem;font-size:.95rem;">Upload files to populate pay data. Generate JSON uses only data from these uploads.</p>

                    <!-- BAH Rates -->
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div>
                                <strong>BAH Rates</strong>
                                <p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Excel with &quot;With&quot; and &quot;Without&quot; dependents sheets. Row 1 = headers (MHA, MHA_NAME, then pay grade columns O-10 through E-1 in any order). Columns are matched by header name so order does not matter.</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.75rem;">
                                <span data-bind="text: bahRatesStatus, css: {'milpay-status-ok': bahRatesStatus() === 'Parsed', 'milpay-status-pending': bahRatesStatus() !== 'Parsed'}" class="milpay-status"></span>
                                <label class="milpay-upload-btn">
                                    Choose .xlsx
                                    <input type="file" accept=".xlsx" style="display:none;" data-bind="event: {change: handleBahRatesUpload}" />
                                </label>
                            </div>
                        </div>
                        <div data-bind="visible: bahRatesCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;">
                            <span data-bind="text: bahRatesCount"></span> locations loaded, <span data-bind="text: cboZipCount"></span> duty stations extracted.
                        </div>
                    </div>

                    <!-- ZipCode Mapping -->
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div>
                                <strong>ZipCode Mapping</strong>
                                <p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Text file mapping ZIP codes to BAH station codes. Format: ZIPCODE STATIONCODE</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.75rem;">
                                <span data-bind="text: zipCodeMappingStatus, css: {'milpay-status-ok': zipCodeMappingStatus() === 'Parsed', 'milpay-status-pending': zipCodeMappingStatus() !== 'Parsed'}" class="milpay-status"></span>
                                <label class="milpay-upload-btn">
                                    Choose .txt
                                    <input type="file" accept=".txt" style="display:none;" data-bind="event: {change: handleZipCodeMappingUpload}" />
                                </label>
                            </div>
                        </div>
                        <div data-bind="visible: zipCodeMappingCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;">
                            <span data-bind="text: zipCodeMappingCount"></span> zip codes mapped.
                        </div>
                    </div>

                    <!-- COLA Zips -->
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div>
                                <strong>COLA Zips</strong>
                                <p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Text file mapping ZIP codes to COLA rates. Format: ZIPCODE;RATE;LOCATION</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.75rem;">
                                <span data-bind="text: colaZipsStatus, css: {'milpay-status-ok': colaZipsStatus() === 'Parsed', 'milpay-status-pending': colaZipsStatus() !== 'Parsed'}" class="milpay-status"></span>
                                <label class="milpay-upload-btn">
                                    Choose .txt
                                    <input type="file" accept=".txt" style="display:none;" data-bind="event: {change: handleColaZipsUpload}" />
                                </label>
                            </div>
                        </div>
                        <div data-bind="visible: colaZipsCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;">
                            <span data-bind="text: colaZipsCount"></span> COLA zip entries loaded.
                        </div>
                    </div>

                    <!-- COLA With Dependents -->
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div>
                                <strong>COLA With Dependents</strong>
                                <p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Text file with COLA rates with dependents. Left column = pay grade (O-10 to E-1), columns to the right = years of service. Semicolon-delimited: PAYGRADE;val_&lt;2yr;val_2;val_3;...</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.75rem;">
                                <span data-bind="text: colaWithDepsStatus, css: {'milpay-status-ok': colaWithDepsStatus() === 'Parsed', 'milpay-status-pending': colaWithDepsStatus() !== 'Parsed'}" class="milpay-status"></span>
                                <label class="milpay-upload-btn">
                                    Choose .txt
                                    <input type="file" accept=".txt" style="display:none;" data-bind="event: {change: handleColaWithDepsUpload}" />
                                </label>
                            </div>
                        </div>
                        <div data-bind="visible: colaWithDepsCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;">
                            <span data-bind="text: colaWithDepsCount"></span> paygrade entries loaded.
                        </div>
                    </div>

                    <!-- COLA Without Dependents -->
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div>
                                <strong>COLA Without Dependents</strong>
                                <p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Text file with COLA rates without dependents. Left column = pay grade (O-10 to E-1), columns to the right = years of service. Semicolon-delimited: PAYGRADE;val_&lt;2yr;val_2;val_3;...</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.75rem;">
                                <span data-bind="text: colaWithoutDepsStatus, css: {'milpay-status-ok': colaWithoutDepsStatus() === 'Parsed', 'milpay-status-pending': colaWithoutDepsStatus() !== 'Parsed'}" class="milpay-status"></span>
                                <label class="milpay-upload-btn">
                                    Choose .txt
                                    <input type="file" accept=".txt" style="display:none;" data-bind="event: {change: handleColaWithoutDepsUpload}" />
                                </label>
                            </div>
                        </div>
                        <div data-bind="visible: colaWithoutDepsCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;">
                            <span data-bind="text: colaWithoutDepsCount"></span> paygrade entries loaded.
                        </div>
                    </div>

                    <!-- Active Duty Pay -->
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div>
                                <strong>Active Duty Pay</strong>
                                <p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Excel file with base pay. Rows: pay grades (O-10 to E-1). Columns: years of service.</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.75rem;">
                                <span data-bind="text: activeDutyPayStatus, css: {'milpay-status-ok': activeDutyPayStatus() === 'Parsed', 'milpay-status-pending': activeDutyPayStatus() !== 'Parsed'}" class="milpay-status"></span>
                                <label class="milpay-upload-btn">
                                    Choose .xlsx
                                    <input type="file" accept=".xlsx" style="display:none;" data-bind="event: {change: handleActiveDutyPayUpload}" />
                                </label>
                            </div>
                        </div>
                        <div data-bind="visible: activeDutyPayCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;">
                            <span data-bind="text: activeDutyPayCount"></span> base pay entries loaded.
                        </div>
                    </div>

                    <!-- Drill Pay -->
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div>
                                <strong>Drill Pay</strong>
                                <p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Excel file with drill pay rates. Rows: pay grades. Columns: years of service.</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.75rem;">
                                <span data-bind="text: drillPayStatus, css: {'milpay-status-ok': drillPayStatus() === 'Parsed', 'milpay-status-pending': drillPayStatus() !== 'Parsed'}" class="milpay-status"></span>
                                <label class="milpay-upload-btn">
                                    Choose .xlsx
                                    <input type="file" accept=".xlsx" style="display:none;" data-bind="event: {change: handleDrillPayUpload}" />
                                </label>
                            </div>
                        </div>
                        <div data-bind="visible: drillPayCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;">
                            <span data-bind="text: drillPayCount"></span> drill pay entries loaded.
                        </div>
                    </div>
                </div>

                <!-- ==================== GENERAL SETTINGS TAB ==================== -->
                <div data-bind="visible: activeTab() === 'general'">
                    <div class="milpay-tab-toolbar" data-bind="visible: hasCollapsibleSections()">
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: expandAllSections">Expand All</button>
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: collapseAllSections">Collapse All</button>
                    </div>
                    <div class="milpay-field-grid">
                        <div class="milpay-field">
                            <label class="form-label">Pay Calculator Year</label>
                            <input type="number" class="form-control" data-bind="value: payCalculatorYear" />
                        </div>
                        <div class="milpay-field">
                            <label class="form-label">BAH Rate Year</label>
                            <input type="number" class="form-control" data-bind="value: bahRateYear" />
                        </div>
                    </div>

                    <div class="milpay-field" style="margin-top:1rem;">
                        <label class="form-label">Active Duty Pay Chart URL</label>
                        <input type="text" class="form-control" data-bind="value: activeDutyPayChartUrl" placeholder="https://..." />
                    </div>
                    <div class="milpay-field" style="margin-top:.75rem;">
                        <label class="form-label">Drill Pay Chart URL</label>
                        <input type="text" class="form-control" data-bind="value: drillPayPaychartUrl" placeholder="https://..." />
                    </div>
                    <div class="milpay-field" style="margin-top:.75rem;">
                        <label class="form-label">BAH Rate With Dependents URL</label>
                        <input type="text" class="form-control" data-bind="value: bahRateWithDependantUrl" placeholder="https://..." />
                    </div>
                    <div class="milpay-field" style="margin-top:.75rem;">
                        <label class="form-label">BAH Rate Without Dependents URL</label>
                        <input type="text" class="form-control" data-bind="value: bahRateWithoutDependantUrl" placeholder="https://..." />
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_general_bas'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_general_bas')}">
                            <span class="milpay-section-title-text">Subsistence Allowance (BAS) by Pay Grade</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_general_bas')">
                            <p style="color:#6c757d;font-size:.95rem;">Set the monthly Basic Allowance for Subsistence for each pay grade.</p>
                            <div class="milpay-field-grid milpay-field-grid-3">
                                <!-- ko foreach: substistanceAllowancePayList -->
                                <div class="milpay-field">
                                    <label class="form-label" data-bind="text: label"></label>
                                    <div style="position:relative;">
                                        <span style="position:absolute;left:.75rem;top:50%;transform:translateY(-50%);color:#6c757d;">$</span>
                                        <input type="number" step="0.01" class="form-control" style="padding-left:1.5rem;" data-bind="value: value" />
                                    </div>
                                </div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== SPECIAL PAY TAB ==================== -->
                <div data-bind="visible: activeTab() === 'special'">
                    <div class="milpay-tab-toolbar" data-bind="visible: hasCollapsibleSections()">
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: expandAllSections">Expand All</button>
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: collapseAllSections">Collapse All</button>
                    </div>

                    <!-- Hazardous Duty Pay -->
                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_hazardous'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_hazardous')}">
                            <span class="milpay-section-title-text">Hazardous Duty Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_hazardous')">
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <div class="milpay-field">
                                <label class="form-label">Imminent Danger Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: imminentDangerPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Hostile Fire Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: hostilePay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Demolition Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: demolitionPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Jump Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: jumpPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">HALO Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: haloPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Flight Deck Duty Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: flightDeckDutyPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Hazard Pay (Non-Crewmember)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: hazardPayNonCrewmemberPay" /></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <!-- Special Allowance Pay -->
                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_allowance'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_allowance')}">
                            <span class="milpay-section-title-text">Special Allowance Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_allowance')">
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <div class="milpay-field">
                                <label class="form-label">Single Foreign Language Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: singleForeignLanguagePay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Multiple Foreign Language Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: multipleForeignLanguagePay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Extended Duty Special Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: extendedDutySpecialPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Separation Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: separationPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Asymmetric Warfare Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: assymetricWarfarePay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Military Intelligence Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: militaryIntelligencePay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Command Sergeant Major Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: commandSergeantMajorPay" /></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <!-- Coast Guard Specific -->
                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_coastguard'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_coastguard')}">
                            <span class="milpay-section-title-text">Coast Guard Specific</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_coastguard')">
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <div class="milpay-field">
                                <label class="form-label">MSST/TACLET Leader Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: msstTacletLeaderPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">CG Diver Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: cgDiverPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Rescue Swimmer Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: rescueSwimmerPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Surfman Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: surfmanPay" /></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <!-- Special Missions -->
                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_missions'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_missions')}">
                            <span class="milpay-section-title-text">Special Missions Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_missions')">
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <div class="milpay-field">
                                <label class="form-label">Less than 3 years</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: specialMissionsPay1" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">More than 3 years</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: specialMissionsPay2" /></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <!-- Manual data not from file uploads (paste JSON) -->
                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_manual'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_manual')}">
                            <span class="milpay-section-title-text">Manual Builders</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_manual')">
                            <div class="milpay-section milpay-section-collapsible" style="margin-bottom:1.5rem;">
                                <h5 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_manual_seapay'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_manual_seapay')}">
                                    <span class="milpay-section-title-text">Sea Pay Matrix Builder</span>
                                    <span class="milpay-section-chevron" aria-hidden="true"></span>
                                </h5>
                                <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_manual_seapay')">
                                    <div class="milpay-field milpay-seapay-builder" style="margin-bottom:0;">
                                        <div class="milpay-seapay-summary" data-bind="with: getSeaPayMatrixEditorSummary()">
                                            <span class="milpay-seapay-chip" data-bind="text: branchCount + ' branches'"></span>
                                            <span class="milpay-seapay-chip" data-bind="text: totalRows + ' rows'"></span>
                                        </div>
                                        <div class="milpay-seapay-branches">
                                            <!-- ko foreach: seaPayMatrixBranchIds -->
                                            <div class="milpay-section milpay-section-collapsible milpay-seapay-branch" data-bind="attr: { 'data-branch': $data }">
                                                <h5 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ $parent.toggleSection('seapay_branch_' + $data); }, css: {'milpay-section-collapsed': $parent.isSectionCollapsed('seapay_branch_' + $data)}">
                                                    <span class="milpay-section-title-text" data-bind="text: $parent.seaPayMatrixBranchLabel($data)"></span>
                                                    <span class="milpay-seapay-branch-count" data-bind="text: '(' + $parent.seaPayMatrixEditorRowsByBranch[$data]().length + ' rows)'"></span>
                                                    <span class="milpay-section-chevron" aria-hidden="true"></span>
                                                </h5>
                                                <div class="milpay-section-body" data-bind="visible: !$parent.isSectionCollapsed('seapay_branch_' + $data)">
                                                    <div class="milpay-seapay-toolbar">
                                                        <button type="button" class="milpay-toolbar-btn" data-bind="click: function(){ $parent.addSeaPayRow($data); }">Add row</button>
                                                        <button type="button" class="milpay-toolbar-btn milpay-btn-secondary" data-bind="click: function(){ $parent.resetSeaPayBranch($data); }, visible: $parent.seaPayMatrixEditorRowsByBranch[$data]().length > 0">Reset branch</button>
                                                    </div>
                                                    <table class="milpay-seapay-table">
                                                        <thead><tr><th>Pay grade</th><th>Years of sea duty</th><th>Amount ($)</th><th></th></tr></thead>
                                                        <tbody data-bind="foreach: $parent.seaPayMatrixEditorRowsByBranch[$data]">
                                                            <tr>
                                                                <td>
                                                                    <select class="form-control form-control-sm" data-bind="options: $parents[1].seaPayMatrixPaygradeOptions, optionsText: 'name', optionsValue: 'value', value: paygrade"></select>
                                                                </td>
                                                                <td>
                                                                    <select class="form-control form-control-sm" data-bind="options: $parents[1].seaPayMatrixYearsOptions, optionsText: 'name', optionsValue: 'value', value: yearsOfSeaDuty"></select>
                                                                </td>
                                                                <td>
                                                                    <div class="milpay-seapay-amount"><span class="milpay-dollar">$</span><input type="number" class="form-control form-control-sm milpay-dollar-input" data-bind="value: value" min="0" step="1" /></div>
                                                                </td>
                                                                <td class="milpay-seapay-actions">
                                                                    <button type="button" class="milpay-seapay-btn" title="Duplicate row" data-bind="click: function(){ $parents[1].duplicateSeaPayRow($parents[0], $data); }">Copy</button>
                                                                    <button type="button" class="milpay-seapay-btn milpay-seapay-btn-del" title="Delete row" data-bind="click: function(){ $parents[1].removeSeaPayRow($parents[0], $data); }">Delete</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="milpay-section milpay-section-collapsible" style="margin-bottom:1.5rem;">
                                <h5 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_manual_submarine'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_manual_submarine')}">
                                    <span class="milpay-section-title-text">Submarine Pay Builder</span>
                                    <span class="milpay-section-chevron" aria-hidden="true"></span>
                                </h5>
                                <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_manual_submarine')">
                                    <div class="milpay-field milpay-seapay-builder" style="margin-bottom:0;">
                                        <div class="milpay-seapay-summary" data-bind="with: getSubmarinePayEditorSummary()">
                                            <span class="milpay-seapay-chip" data-bind="text: totalRows + ' rows'"></span>
                                        </div>
                                        <div class="milpay-seapay-toolbar">
                                            <button type="button" class="milpay-toolbar-btn" data-bind="click: addSubmarinePayRow">Add row</button>
                                            <button type="button" class="milpay-toolbar-btn milpay-btn-secondary" data-bind="click: resetSubmarinePay, visible: submarinePayEditorRows().length > 0">Reset list</button>
                                        </div>
                                        <table class="milpay-seapay-table">
                                            <thead><tr><th>Pay grade</th><th>Years of sub experience</th><th>Amount ($)</th><th></th></tr></thead>
                                            <tbody data-bind="foreach: submarinePayEditorRows">
                                                <tr>
                                                    <td>
                                                        <select class="form-control form-control-sm" data-bind="options: $parent.submarinePayPaygradeOptions, optionsText: 'name', optionsValue: 'value', value: paygrade"></select>
                                                    </td>
                                                    <td>
                                                        <select class="form-control form-control-sm" data-bind="options: $parent.submarinePayYearsOptions, optionsText: 'name', optionsValue: 'value', value: yearsOfSubmarineExperience"></select>
                                                    </td>
                                                    <td>
                                                        <div class="milpay-seapay-amount"><span class="milpay-dollar">$</span><input type="number" class="form-control form-control-sm milpay-dollar-input" data-bind="value: value" min="0" step="1" /></div>
                                                    </td>
                                                    <td class="milpay-seapay-actions">
                                                        <button type="button" class="milpay-seapay-btn" title="Duplicate row" data-bind="click: function(){ $parent.duplicateSubmarinePayRow($data); }">Copy</button>
                                                        <button type="button" class="milpay-seapay-btn milpay-seapay-btn-del" title="Delete row" data-bind="click: function(){ $parent.removeSubmarinePayRow($data); }">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="milpay-section milpay-section-collapsible" style="margin-bottom:1.5rem;">
                                <h5 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_manual_awacs'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_manual_awacs')}">
                                    <span class="milpay-section-title-text">AWACS Pay Builder (Hazardous Duty Crewmember)</span>
                                    <span class="milpay-section-chevron" aria-hidden="true"></span>
                                </h5>
                                <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_manual_awacs')">
                                    <div class="milpay-field milpay-seapay-builder" style="margin-bottom:0;">
                                        <div class="milpay-seapay-summary" data-bind="with: getAwacsPayEditorSummary()">
                                            <span class="milpay-seapay-chip" data-bind="text: totalRows + ' rows'"></span>
                                        </div>
                                        <div class="milpay-seapay-toolbar">
                                            <button type="button" class="milpay-toolbar-btn" data-bind="click: addAwacsPayRow">Add row</button>
                                            <button type="button" class="milpay-toolbar-btn milpay-btn-secondary" data-bind="click: resetAwacsPay, visible: awacsPayEditorRows().length > 0">Reset list</button>
                                        </div>
                                        <table class="milpay-seapay-table">
                                            <thead><tr><th>Pay grade</th><th>Years of duty</th><th>Amount ($)</th><th></th></tr></thead>
                                            <tbody data-bind="foreach: awacsPayEditorRows">
                                                <tr>
                                                    <td>
                                                        <select class="form-control form-control-sm" data-bind="options: $parent.awacsPayPaygradeOptions, optionsText: 'name', optionsValue: 'value', value: paygrade"></select>
                                                    </td>
                                                    <td>
                                                        <select class="form-control form-control-sm" data-bind="options: $parent.awacsPayYearsOptions, optionsText: 'name', optionsValue: 'value', value: yearsOfDuty"></select>
                                                    </td>
                                                    <td>
                                                        <div class="milpay-seapay-amount"><span class="milpay-dollar">$</span><input type="number" class="form-control form-control-sm milpay-dollar-input" data-bind="value: value" min="0" step="1" /></div>
                                                    </td>
                                                    <td class="milpay-seapay-actions">
                                                        <button type="button" class="milpay-seapay-btn" title="Duplicate row" data-bind="click: function(){ $parent.duplicateAwacsPayRow($data); }">Copy</button>
                                                        <button type="button" class="milpay-seapay-btn milpay-seapay-btn-del" title="Delete row" data-bind="click: function(){ $parent.removeAwacsPayRow($data); }">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="milpay-section milpay-section-collapsible" style="margin-bottom:1.5rem;">
                                <h5 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_manual_hdp'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_manual_hdp')}">
                                    <span class="milpay-section-title-text">HDP Locations Builder (cboHDP)</span>
                                    <span class="milpay-section-chevron" aria-hidden="true"></span>
                                </h5>
                                <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_manual_hdp')">
                                    <div class="milpay-field milpay-seapay-builder" style="margin-bottom:0;">
                                        <div class="milpay-seapay-summary" data-bind="with: getCboHDPEditorSummary()">
                                            <span class="milpay-seapay-chip" data-bind="text: totalRows + ' rows'"></span>
                                        </div>
                                        <div class="milpay-seapay-toolbar">
                                            <button type="button" class="milpay-toolbar-btn" data-bind="click: addCboHDPRow">Add row</button>
                                            <button type="button" class="milpay-toolbar-btn milpay-btn-secondary" data-bind="click: resetCboHDP, visible: cboHDPEditorRows().length > 0">Reset list</button>
                                        </div>
                                        <table class="milpay-seapay-table">
                                            <thead><tr><th>Location</th><th>Amount ($)</th><th></th></tr></thead>
                                            <tbody data-bind="foreach: cboHDPEditorRows">
                                                <tr>
                                                    <td>
                                                        <input type="text" class="form-control form-control-sm" data-bind="value: name" />
                                                    </td>
                                                    <td>
                                                        <div class="milpay-seapay-amount"><span class="milpay-dollar">$</span><input type="number" class="form-control form-control-sm milpay-dollar-input" data-bind="value: value" step="1" /></div>
                                                    </td>
                                                    <td class="milpay-seapay-actions">
                                                        <button type="button" class="milpay-seapay-btn" title="Duplicate row" data-bind="click: function(){ $parent.duplicateCboHDPRow($data); }">Copy</button>
                                                        <button type="button" class="milpay-seapay-btn milpay-seapay-btn-del" title="Delete row" data-bind="click: function(){ $parent.removeCboHDPRow($data); }">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="milpay-section milpay-section-collapsible" style="margin-bottom:0;">
                                <h5 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_special_manual_diving'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_special_manual_diving')}">
                                    <span class="milpay-section-title-text">Diving Pay Options Builder (cboDivingPay)</span>
                                    <span class="milpay-section-chevron" aria-hidden="true"></span>
                                </h5>
                                <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_special_manual_diving')">
                                    <div class="milpay-field milpay-seapay-builder" style="margin-bottom:0;">
                                        <div class="milpay-seapay-summary" data-bind="with: getCboDivingPayEditorSummary()">
                                            <span class="milpay-seapay-chip" data-bind="text: totalRows + ' rows'"></span>
                                        </div>
                                        <div class="milpay-seapay-toolbar">
                                            <button type="button" class="milpay-toolbar-btn" data-bind="click: addCboDivingPayRow">Add row</button>
                                            <button type="button" class="milpay-toolbar-btn milpay-btn-secondary" data-bind="click: resetCboDivingPay, visible: cboDivingPayEditorRows().length > 0">Reset list</button>
                                        </div>
                                        <table class="milpay-seapay-table">
                                            <thead><tr><th>Option</th><th>Amount ($)</th><th></th></tr></thead>
                                            <tbody data-bind="foreach: cboDivingPayEditorRows">
                                                <tr>
                                                    <td>
                                                        <input type="text" class="form-control form-control-sm" data-bind="value: name" />
                                                    </td>
                                                    <td>
                                                        <div class="milpay-seapay-amount"><span class="milpay-dollar">$</span><input type="number" class="form-control form-control-sm milpay-dollar-input" data-bind="value: value" step="1" /></div>
                                                    </td>
                                                    <td class="milpay-seapay-actions">
                                                        <button type="button" class="milpay-seapay-btn" title="Duplicate row" data-bind="click: function(){ $parent.duplicateCboDivingPayRow($data); }">Copy</button>
                                                        <button type="button" class="milpay-seapay-btn milpay-seapay-btn-del" title="Delete row" data-bind="click: function(){ $parent.removeCboDivingPayRow($data); }">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== DIVING & EOD TAB ==================== -->
                <div data-bind="visible: activeTab() === 'diving'">
                    <div class="milpay-tab-toolbar" data-bind="visible: hasCollapsibleSections()">
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: expandAllSections">Expand All</button>
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: collapseAllSections">Collapse All</button>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_diving_general'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_diving_general')}">
                            <span class="milpay-section-title-text">General Diving Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_diving_general')">
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <div class="milpay-field">
                                <label class="form-label">Master Diver Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: masterDiverPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Salvage Diver Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: salvageDiverPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Combatant Diver Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: combatantDiverPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Combat Diver Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: combatDiverPay" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Para Rescue Diver Pay</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: paraRescueDiverPay" /></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_diving_class'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_diving_class')}">
                            <span class="milpay-section-title-text">Diver Class Pay (by Branch)</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_diving_class')">
                        <div class="milpay-field-grid milpay-field-grid-4">
                            <div class="milpay-field">
                                <label class="form-label">1st Class - Army (3)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: diverFirstClassPay3" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">1st Class - Navy (4)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: diverFirstClassPay4" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">2nd Class - Army (3)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: diverSecondClassPay3" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">2nd Class - Navy (4)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: diverSecondClassPay4" /></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_diving_officer'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_diving_officer')}">
                            <span class="milpay-section-title-text">Diving Officer & Scuba Pay (by Branch)</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_diving_officer')">
                        <div class="milpay-field-grid milpay-field-grid-4">
                            <div class="milpay-field">
                                <label class="form-label">Diving Officer - O-9 (2)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: divingOfficerPay2" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Diving Officer - O-8 (3)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: divingOfficerPay3" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Scuba - O-9 (2)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: scubaPay2" /></div>
                            </div>
                            <div class="milpay-field">
                                <label class="form-label">Scuba - Navy (4)</label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: scubaPay4" /></div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_diving_navy'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_diving_navy')}">
                            <span class="milpay-section-title-text">Navy-Specific Diving Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_diving_navy')">
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <div class="milpay-field"><label class="form-label">Combatant Swimmer</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: combatantSwimmerNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Basic Combatant Swimmer</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: basicCombatantSwimmerNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Master UCT Diver</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: masterUCTDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Advanced UCT Diver</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: advancedUCTDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Basic UCT Diver</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: basicUCTDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Scuba Diver</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: scubaDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Medical Diving Tech</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: medicalDivingTechNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Medical Diver Saturation</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: medicalDiverSaturationNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Diver In Training</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: diverInTrainingNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Saturation Diver</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: saturationDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">SEAL Delivery Vehicle Pilot</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: sealDeliveryVehiclePilotNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Special Warfare Operator</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: specialWarfareOperatorNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Medical Special Ops Tech</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: medicalSpecialOpsTechNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Spec Recon Fleet Corpsman</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: specReconFleetCorpsmanNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Medical Diving Officer</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: medicalDivingOfficerNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Diving CWO</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: divingCWONavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Special Warfare Officer</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: specialWarfareOfficerNavyPay" /></div></div>
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_diving_eod'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_diving_eod')}">
                            <span class="milpay-section-title-text">EOD Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_diving_eod')">
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <div class="milpay-field"><label class="form-label">EOD Diver (Navy)</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: eodDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">EOD Assistant (Navy)</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: eodAssistantNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Basic EOD Tech Diver (Navy)</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: basicEODTechDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Sr EOD Tech Diver (Navy)</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: srEodTechDiverNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">Master EOD Tech (Navy)</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: masterEODTechNavyPay" /></div></div>
                            <div class="milpay-field"><label class="form-label">EOD Officer (Navy)</label><div style="position:relative;"><span class="milpay-dollar">$</span><input type="number" class="form-control milpay-dollar-input" data-bind="value: eodOfficerNavyPay" /></div></div>
                        </div>
                        <h5 style="margin-top:1rem;">EOD Pay by Category</h5>
                        <div class="milpay-field-grid milpay-field-grid-3">
                            <!-- ko foreach: eodPayList -->
                            <div class="milpay-field">
                                <label class="form-label" data-bind="text: label"></label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: value" /></div>
                            </div>
                            <!-- /ko -->
                        </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== AVIATION PAY TAB ==================== -->
                <div data-bind="visible: activeTab() === 'aviation'">
                    <div class="milpay-tab-toolbar" data-bind="visible: hasCollapsibleSections()">
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: expandAllSections">Expand All</button>
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: collapseAllSections">Collapse All</button>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_aviation_af_flyers'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_aviation_af_flyers')}">
                            <span class="milpay-section-title-text">Air Force Enlisted Flyers Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_aviation_af_flyers')">
                        <div class="milpay-field-grid milpay-field-grid-4">
                            <!-- ko foreach: airForceEnlistedPayList -->
                            <div class="milpay-field">
                                <label class="form-label" data-bind="text: label"></label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: value" /></div>
                            </div>
                            <!-- /ko -->
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_aviation_career'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_aviation_career')}">
                            <span class="milpay-section-title-text">Aviation Career Incentive Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_aviation_career')">
                        <div class="milpay-field-grid milpay-field-grid-5">
                            <!-- ko foreach: aviationExperiencePayList -->
                            <div class="milpay-field">
                                <label class="form-label" data-bind="text: label"></label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: value" /></div>
                            </div>
                            <!-- /ko -->
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_aviation_af_aviation'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_aviation_af_aviation')}">
                            <span class="milpay-section-title-text">Air Force Aviation Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_aviation_af_aviation')">
                        <div class="milpay-field-grid milpay-field-grid-4">
                            <!-- ko foreach: airForceAviationExperiencePayList -->
                            <div class="milpay-field">
                                <label class="form-label" data-bind="text: label"></label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: value" /></div>
                            </div>
                            <!-- /ko -->
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_aviation_navy_flyers'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_aviation_navy_flyers')}">
                            <span class="milpay-section-title-text">Navy Enlisted Flyers Pay</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_aviation_navy_flyers')">
                        <div class="milpay-field-grid milpay-field-grid-4">
                            <!-- ko foreach: navyEnlistedPayList -->
                            <div class="milpay-field">
                                <label class="form-label" data-bind="text: label"></label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: value" /></div>
                            </div>
                            <!-- /ko -->
                        </div>
                        </div>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_aviation_hdip'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_aviation_hdip')}">
                            <span class="milpay-section-title-text">Hazard Pay HDIP Crew Member by Pay Grade</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_aviation_hdip')">
                        <div class="milpay-field-grid milpay-field-grid-5">
                            <!-- ko foreach: hazardPayHDIPList -->
                            <div class="milpay-field">
                                <label class="form-label" data-bind="text: label"></label>
                                <div style="position:relative;"><span class="milpay-dollar">$</span>
                                <input type="number" class="form-control milpay-dollar-input" data-bind="value: value" /></div>
                            </div>
                            <!-- /ko -->
                        </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== ALLOWANCES TAB ==================== -->
                <div data-bind="visible: activeTab() === 'summary'">
                    <div class="milpay-tab-toolbar" data-bind="visible: hasCollapsibleSections()">
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: expandAllSections">Expand All</button>
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: collapseAllSections">Collapse All</button>
                    </div>
                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_summary'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_summary')}">
                            <span class="milpay-section-title-text">Data Summary</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_summary')">
                        <table class="milpay-summary-table">
                            <thead><tr><th>Data Section</th><th>Status</th><th>Count</th></tr></thead>
                            <tbody>
                                <tr><td>Base Pay Matrix</td><td data-bind="text: basePayMatrixData() ? 'Loaded' : 'Empty'"></td><td data-bind="text: basePayMatrixData() ? basePayMatrixData().length : 0"></td></tr>
                                <tr><td>Sea Pay Matrix</td><td data-bind="text: seaPayMatrixEditorSummaryStatus"></td><td data-bind="text: seaPayMatrixEditorSummaryCount"></td></tr>
                                <tr><td>Housing Allowance</td><td data-bind="text: housingAllowanceData() ? 'Loaded' : 'Empty'"></td><td data-bind="text: housingAllowanceData() ? Object.keys(housingAllowanceData()).length + ' locations' : 0"></td></tr>
                                <tr><td>Submarine Pay</td><td data-bind="text: submarinePayEditorSummaryStatus"></td><td data-bind="text: submarinePayEditorSummaryCount"></td></tr>
                                <tr><td>AWACS Pay</td><td data-bind="text: awacsPayEditorSummaryStatus"></td><td data-bind="text: awacsPayEditorSummaryCount"></td></tr>
                                <tr><td>HDP Locations</td><td data-bind="text: cboHDPEditorSummaryStatus"></td><td data-bind="text: cboHDPEditorSummaryCount"></td></tr>
                                <tr><td>Diving Pay Options</td><td data-bind="text: cboDivingPayData() ? 'Loaded' : 'Empty'"></td><td data-bind="text: cboDivingPayData() ? cboDivingPayData().length : 0"></td></tr>
                                <tr><td>COLA Base Pay (With Deps)</td><td data-bind="text: colaBasePayWithDepsData() ? 'Loaded' : 'Empty'"></td><td data-bind="text: colaBasePayWithDepsData() ? colaBasePayWithDepsData().length : 0"></td></tr>
                                <tr><td>COLA Base Pay (Without Deps)</td><td data-bind="text: colaBasePayWithoutDepsData() ? 'Loaded' : 'Empty'"></td><td data-bind="text: colaBasePayWithoutDepsData() ? colaBasePayWithoutDepsData().length : 0"></td></tr>
                                <tr><td>Zip Code to Station</td><td data-bind="text: zipCode2DutyStationData() ? 'Loaded' : 'Empty'"></td><td data-bind="text: zipCode2DutyStationData() ? Object.keys(zipCode2DutyStationData()).length : 0"></td></tr>
                                <tr><td>COLA Rate With Dependant</td><td data-bind="text: colaRateWithDependantData() ? 'Loaded' : 'Empty'"></td><td data-bind="text: colaRateWithDependantData() ? Object.keys(colaRateWithDependantData()).length : 0"></td></tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>

                <!-- ==================== GENERATE TAB ==================== -->
                <div data-bind="visible: activeTab() === 'generate'">
                    <div class="milpay-tab-toolbar" data-bind="visible: hasCollapsibleSections()">
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: expandAllSections">Expand All</button>
                        <button type="button" class="milpay-toolbar-btn" data-bind="click: collapseAllSections">Collapse All</button>
                    </div>

                    <div class="milpay-section milpay-section-collapsible">
                        <h4 class="milpay-section-title milpay-section-toggle" data-bind="click: function(){ toggleSection('section_generate_readiness'); }, css: {'milpay-section-collapsed': isSectionCollapsed('section_generate_readiness')}">
                            <span class="milpay-section-title-text">Readiness Check</span>
                            <span class="milpay-section-chevron" aria-hidden="true"></span>
                        </h4>
                        <div class="milpay-section-body" data-bind="visible: !isSectionCollapsed('section_generate_readiness')">
                        <div class="milpay-checklist">
                            <div class="milpay-check-item">
                                <span data-bind="css: {'milpay-check-ok': bahRatesStatus() === 'Parsed', 'milpay-check-warn': bahRatesStatus() !== 'Parsed'}">&#x25cf;</span>
                                <span>BAH Rates: <strong data-bind="text: bahRatesStatus"></strong></span>
                            </div>
                            <div class="milpay-check-item">
                                <span data-bind="css: {'milpay-check-ok': zipCodeMappingStatus() === 'Parsed', 'milpay-check-warn': zipCodeMappingStatus() !== 'Parsed'}">&#x25cf;</span>
                                <span>ZipCode Mapping: <strong data-bind="text: zipCodeMappingStatus"></strong></span>
                            </div>
                            <div class="milpay-check-item">
                                <span data-bind="css: {'milpay-check-ok': colaZipsStatus() === 'Parsed', 'milpay-check-warn': colaZipsStatus() !== 'Parsed'}">&#x25cf;</span>
                                <span>COLA Zips: <strong data-bind="text: colaZipsStatus"></strong></span>
                            </div>
                            <div class="milpay-check-item">
                                <span data-bind="css: {'milpay-check-ok': colaWithDepsStatus() === 'Parsed', 'milpay-check-warn': colaWithDepsStatus() !== 'Parsed'}">&#x25cf;</span>
                                <span>COLA With Dependents: <strong data-bind="text: colaWithDepsStatus"></strong></span>
                            </div>
                            <div class="milpay-check-item">
                                <span data-bind="css: {'milpay-check-ok': colaWithoutDepsStatus() === 'Parsed', 'milpay-check-warn': colaWithoutDepsStatus() !== 'Parsed'}">&#x25cf;</span>
                                <span>COLA Without Dependents: <strong data-bind="text: colaWithoutDepsStatus"></strong></span>
                            </div>
                            <div class="milpay-check-item">
                                <span data-bind="css: {'milpay-check-ok': activeDutyPayStatus() === 'Parsed', 'milpay-check-warn': activeDutyPayStatus() !== 'Parsed'}">&#x25cf;</span>
                                <span>Active Duty Pay: <strong data-bind="text: activeDutyPayStatus"></strong></span>
                            </div>
                            <div class="milpay-check-item">
                                <span data-bind="css: {'milpay-check-ok': drillPayStatus() === 'Parsed', 'milpay-check-warn': drillPayStatus() !== 'Parsed'}">&#x25cf;</span>
                                <span>Drill Pay: <strong data-bind="text: drillPayStatus"></strong></span>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div style="display:flex;gap:1rem;margin-top:1.5rem;">
                        <button class="w-btn w-btn-primary" style="padding:.75rem 2rem;font-size:1rem;" data-bind="click: generateJson">Generate JSON</button>
                        <button class="w-btn" style="padding:.75rem 2rem;font-size:1rem;" data-bind="click: downloadJson, enable: generatedJson()">Download JSON</button>
                        <button class="w-btn" style="padding:.75rem 2rem;font-size:1rem;" data-bind="click: save">Save </button>
                    </div>

                    <div data-bind="visible: generatedJson()" style="margin-top:1.5rem;">
                        <h4>JSON Preview</h4>
                        <textarea readonly style="width:100%;height:400px;font-family:monospace;font-size:.9rem;border:1px solid #dee2e6;border-radius:4px;padding:.75rem;background:#f8f9fa;" data-bind="value: jsonPreview"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <style>
            .milpay-calculator {
                --milpay-primary: #2563eb;
                --milpay-primary-hover: #1d4ed8;
                --milpay-border: #e5e7eb;
                --milpay-border-focus: #2563eb;
                --milpay-bg-section: #fafbfc;
                --milpay-bg-tabs: #f8fafc;
                --milpay-radius: 8px;
                --milpay-radius-sm: 6px;
                --milpay-radius-pill: 9999px;
                --milpay-shadow: 0 1px 3px rgba(0,0,0,.08);
                --milpay-shadow-card: 0 2px 8px rgba(0,0,0,.06);
                --milpay-text: #1f2937;
                --milpay-text-muted: #6b7280;
                --milpay-success: #059669;
                --milpay-warn: #d97706;
                --milpay-error: #dc2626;
                background: #fff;
                border-radius: var(--milpay-radius);
                box-shadow: var(--milpay-shadow);
                overflow: hidden;
            }
            .milpay-calculator .form-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 1.25rem 1.5rem;
                border-bottom: 1px solid var(--milpay-border);
                background: #fff;
            }
            .milpay-calculator .form-header h2 {
                margin: 0;
                font-size: 1.35rem;
                font-weight: 600;
                color: var(--milpay-text);
            }
            .milpay-status-text {
                font-size: .95rem;
                color: var(--milpay-text-muted);
            }
            .milpay-calculator .form-body {
                padding: 1.5rem 1.75rem;
            }
            .milpay-tabs {
                display: flex;
                flex-wrap: wrap;
                gap: 0;
                border-bottom: 2px solid var(--milpay-border);
                background: var(--milpay-bg-tabs);
                padding: 0 .5rem 0 0;
            }
            .milpay-tab {
                padding: .85rem 1.35rem;
                border: none;
                background: transparent;
                cursor: pointer;
                font-size: .95rem;
                font-weight: 500;
                color: var(--milpay-text-muted);
                border-bottom: 2px solid transparent;
                margin-bottom: -2px;
                transition: color .2s ease, background .2s ease, border-color .2s ease;
            }
            .milpay-tab:hover {
                color: var(--milpay-text);
                background: rgba(0,0,0,.04);
            }
            .milpay-tab-active {
                color: var(--milpay-primary) !important;
                border-bottom-color: var(--milpay-primary) !important;
                background: transparent !important;
            }
            .milpay-tab-toolbar {
                display: flex;
                justify-content: flex-end;
                gap: .5rem;
                margin-bottom: 1rem;
            }
            .milpay-toolbar-btn {
                padding: .4rem .9rem;
                font-size: .875rem;
                font-weight: 500;
                color: var(--milpay-text-muted);
                background: #fff;
                border: 1px solid var(--milpay-border);
                border-radius: var(--milpay-radius-sm);
                cursor: pointer;
                transition: color .2s ease, background .2s ease, border-color .2s ease;
            }
            .milpay-toolbar-btn:hover {
                color: var(--milpay-primary);
                border-color: var(--milpay-primary);
                background: rgba(37,99,235,.04);
            }
            .milpay-upload-card {
                padding: 1.15rem 1.35rem;
                border: 1px solid var(--milpay-border);
                border-radius: var(--milpay-radius);
                margin-bottom: .85rem;
                background: #fff;
                box-shadow: var(--milpay-shadow);
                transition: box-shadow .2s ease;
            }
            .milpay-upload-card:hover {
                box-shadow: var(--milpay-shadow-card);
            }
            .milpay-upload-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 1rem;
                text-align: left;
            }
            .milpay-upload-btn {
                display: inline-block;
                padding: .55rem 1.25rem;
                background: var(--milpay-primary);
                color: #fff;
                border: none;
                border-radius: var(--milpay-radius-sm);
                cursor: pointer;
                font-size: .9rem;
                font-weight: 500;
                white-space: nowrap;
                transition: background .2s ease, transform .1s ease;
            }
            .milpay-upload-btn:hover {
                background: var(--milpay-primary-hover);
            }
            .milpay-upload-btn:active {
                transform: scale(0.98);
            }
            .milpay-status {
                font-size: .85rem;
                font-weight: 600;
                padding: .3rem .75rem;
                border-radius: var(--milpay-radius-pill);
                white-space: nowrap;
                border: 1px solid transparent;
            }
            .milpay-status-ok {
                background: rgba(5,150,105,.12);
                color: var(--milpay-success);
                border-color: rgba(5,150,105,.25);
            }
            .milpay-status-pending {
                background: rgba(217,119,6,.12);
                color: var(--milpay-warn);
                border-color: rgba(217,119,6,.25);
            }
            .milpay-status-error, .milpay-status-error.milpay-status {
                background: rgba(220,38,38,.12);
                color: var(--milpay-error);
                border-color: rgba(220,38,38,.25);
            }
            .milpay-field-grid {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: .85rem 1.35rem;
            }
            .milpay-field-grid-3 { grid-template-columns: repeat(3, 1fr); }
            .milpay-field-grid-4 { grid-template-columns: repeat(4, 1fr); }
            .milpay-field-grid-5 { grid-template-columns: repeat(5, 1fr); }
            .milpay-field .form-label {
                display: block;
                font-size: .9rem;
                font-weight: 600;
                color: var(--milpay-text);
                margin-bottom: .35rem;
            }
            .milpay-field .form-control {
                width: 100%;
                padding: .55rem .85rem;
                border: 1px solid var(--milpay-border);
                border-radius: var(--milpay-radius-sm);
                font-size: 1rem;
                box-sizing: border-box;
                transition: border-color .2s ease, box-shadow .2s ease;
            }
            .milpay-field .form-control:focus {
                outline: none;
                border-color: var(--milpay-border-focus);
                box-shadow: 0 0 0 3px rgba(37,99,235,.15);
            }
            .milpay-dollar {
                position: absolute;
                left: .85rem;
                top: 50%;
                transform: translateY(-50%);
                color: var(--milpay-text-muted);
                font-size: .95rem;
                background: var(--milpay-bg-section);
                padding: 0 .2rem;
                border-radius: 4px;
            }
            .milpay-dollar-input { padding-left: 1.6rem !important; }
            .milpay-section {
                margin-bottom: 1.35rem;
                padding: 1.15rem 1.35rem;
                border: 1px solid var(--milpay-border);
                border-radius: var(--milpay-radius);
                background: var(--milpay-bg-section);
                box-shadow: var(--milpay-shadow);
            }
            .milpay-section-title {
                margin: 0 0 .75rem;
                font-size: 1.05rem;
                font-weight: 600;
                color: var(--milpay-text);
                border-bottom: 1px solid var(--milpay-border);
                padding-bottom: .5rem;
            }
            .milpay-section-collapsible .milpay-section-title {
                margin: 0;
                padding: 0;
                border-bottom: none;
            }
            .milpay-section-toggle {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: .75rem;
                padding: .5rem 0;
                cursor: pointer;
                user-select: none;
                transition: background .15s ease, color .15s ease;
            }
            .milpay-section-toggle:hover {
                color: var(--milpay-primary);
            }
            .milpay-section-title-text { flex: 1; }
            .milpay-section-chevron {
                flex-shrink: 0;
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 6px solid currentColor;
                margin-top: 2px;
                transition: transform .2s ease;
            }
            .milpay-section-collapsed .milpay-section-chevron {
                transform: rotate(-90deg);
            }
            .milpay-section-body {
                padding-top: .5rem;
            }
            .milpay-section-body .milpay-field-grid { margin-top: 0; }
            .milpay-summary-table {
                width: 100%;
                border-collapse: collapse;
                font-size: .95rem;
                border-radius: var(--milpay-radius-sm);
                overflow: hidden;
                border: 1px solid var(--milpay-border);
            }
            .milpay-summary-table th,
            .milpay-summary-table td {
                padding: .6rem .85rem;
                border-bottom: 1px solid var(--milpay-border);
                text-align: left;
            }
            .milpay-summary-table tr:last-child td { border-bottom: none; }
            .milpay-summary-table tr:nth-child(even) { background: rgba(0,0,0,.02); }
            .milpay-summary-table th {
                background: var(--milpay-bg-tabs);
                font-weight: 600;
                color: var(--milpay-text);
            }
            .milpay-checklist { display: flex; flex-direction: column; gap: .5rem; }
            .milpay-check-item { display: flex; align-items: center; gap: .5rem; font-size: 1rem; }
            .milpay-check-ok { color: var(--milpay-success); }
            .milpay-check-warn { color: var(--milpay-warn); }
            .w-btn {
                padding: .65rem 1.5rem;
                font-size: .95rem;
                font-weight: 500;
                border-radius: var(--milpay-radius-sm);
                cursor: pointer;
                transition: background .2s ease, transform .1s ease;
            }
            .w-btn:active { transform: scale(0.98); }
            .w-btn-primary {
                background: var(--milpay-primary);
                color: #fff;
                border: none;
            }
            .w-btn-primary:hover { background: var(--milpay-primary-hover); }
            .milpay-seapay-builder { border: 1px solid var(--milpay-border); border-radius: var(--milpay-radius-sm); padding: 1rem; background: #fff; }
            .milpay-seapay-summary { display: flex; flex-wrap: wrap; gap: .5rem; margin-bottom: 1rem; }
            .milpay-seapay-chip { background: var(--milpay-bg-tabs); padding: .25rem .6rem; border-radius: var(--milpay-radius-sm); font-size: .9rem; }
            .milpay-seapay-branches { display: flex; flex-direction: column; gap: .5rem; }
            .milpay-seapay-branch { border: 1px solid var(--milpay-border); border-radius: var(--milpay-radius-sm); overflow: hidden; }
            .milpay-seapay-branch .milpay-section-title { font-size: 1rem; padding: .6rem .85rem; }
            .milpay-seapay-branch-count { margin-left: .5rem; font-weight: normal; color: var(--milpay-text-muted, #6c757d); font-size: .9rem; }
            .milpay-seapay-toolbar { margin-bottom: .75rem; display: flex; gap: .5rem; flex-wrap: wrap; }
            .milpay-seapay-table { width: 100%; border-collapse: collapse; font-size: .9rem; margin-bottom: .5rem; }
            .milpay-seapay-table th, .milpay-seapay-table td { padding: .4rem .5rem; border-bottom: 1px solid var(--milpay-border); text-align: left; }
            .milpay-seapay-table th { background: var(--milpay-bg-tabs); font-weight: 600; }
            .milpay-seapay-amount { display: flex; align-items: center; gap: .15rem; }
            .milpay-seapay-amount .milpay-dollar { margin-right: 0; }
            .milpay-seapay-actions { white-space: nowrap; }
            .milpay-seapay-btn { padding: .2rem .5rem; font-size: .8rem; border-radius: 4px; cursor: pointer; border: 1px solid var(--milpay-border); background: #fff; }
            .milpay-seapay-btn:hover { background: var(--milpay-bg-tabs); }
            .milpay-seapay-btn-del { color: #c00; border-color: #e88; }
            .milpay-seapay-btn-del:hover { background: #fee; }
            .milpay-seapay-empty { color: var(--milpay-text-muted, #6c757d); font-size: .9rem; margin: .5rem 0 0; }
            .milpay-btn-secondary { background: #fff; border: 1px solid var(--milpay-border); }
            .milpay-btn-secondary:hover { background: var(--milpay-bg-tabs); }
        </style>
        `;
	}

	protected initPartial(): void {
		const vm = this.getTemplateViewModel();
		if (vm && typeof (vm as any).hydrateSeaPayMatrixFromJson === "function") {
			(vm as any).hydrateSeaPayMatrixFromJson();
		}
		if (vm && typeof (vm as any).hydrateSubmarinePayFromJson === "function") {
			(vm as any).hydrateSubmarinePayFromJson();
		}
		if (vm && typeof (vm as any).hydrateAwacsPayFromJson === "function") {
			(vm as any).hydrateAwacsPayFromJson();
		}
		if (vm && typeof (vm as any).hydrateCboHDPFromJson === "function") {
			(vm as any).hydrateCboHDPFromJson();
		}
		if (vm && typeof (vm as any).hydrateCboDivingPayFromJson === "function") {
			(vm as any).hydrateCboDivingPayFromJson();
		}
	}

	protected getMainElementClasses(): Array<string> {
		return ["w-form", "w-form-large"];
	}

	protected buildViewModel(): any {
		let self = this;

		let basSubList = ko.observableArray([]);
		for (let i = 0; i < PAYGRADE_NAMES.length; i++) {
			basSubList.push({ label: PAYGRADE_NAMES[i], value: ko.observable(0) });
		}

		let eodPayList = ko.observableArray([
			{ label: "Category 20", key: "20", value: ko.observable(400) },
			{ label: "Category 21", key: "21", value: ko.observable(500) },
			{ label: "Category 22", key: "22", value: ko.observable(600) },
		]);

		let airForceEnlistedPayList = ko.observableArray(
			AIR_FORCE_ENLISTED_FLYERS_OPTIONS.map((item) => ({
				label: item.name,
				key: String(item.value),
				value: ko.observable(AIR_FORCE_ENLISTED_PAY_DEFAULTS[String(item.value)] || 0),
			})),
		);

		let aviationExperiencePayList = ko.observableArray(
			YEARS_OF_AVIATION_EXPERIENCE_DEFAULTS.map((item) => ({
				label: item.label,
				value: ko.observable(item.value),
			})),
		);

		let airForceAviationExperiencePayList = ko.observableArray(
			YEARS_OF_AIR_FORCE_AVIATION_EXPERIENCE_DEFAULTS.map((item) => ({
				label: item.label,
				value: ko.observable(item.value),
			})),
		);

		let navyEnlistedPayList = ko.observableArray(
			NAVY_ENLISTED_FLYERS_OPTIONS.map((item) => ({
				label: item.name,
				key: String(item.value),
				value: ko.observable(NAVY_ENLISTED_PAY_DEFAULTS[String(item.value)] || 0),
			})),
		);

		let hazardPayHDIPList = ko.observableArray([]);
		for (let option of PAYGRADE_OPTIONS) {
			hazardPayHDIPList.push({
				label: option.name,
				key: String(option.value),
				value: ko.observable(HDIP_CREW_MEMBER_DEFAULTS[Number(option.value)] || 0),
			});
		}

		let saveStatus = ko.observable("");

		// Collapsible sections: sectionId -> true if collapsed
		let collapsedSectionsObservable = ko.observable({}) as { (): Record<string, boolean>; (v: Record<string, boolean>): void };

		const SECTIONS_BY_TAB: Record<string, string[]> = {
			general: ["section_general_bas"],
			special: [
				"section_special_hazardous",
				"section_special_allowance",
				"section_special_coastguard",
				"section_special_missions",
				"section_special_manual",
				"section_special_manual_seapay",
				"section_special_manual_submarine",
				"section_special_manual_awacs",
				"section_special_manual_hdp",
				"section_special_manual_diving",
				"seapay_branch_1",
				"seapay_branch_2",
				"seapay_branch_3",
				"seapay_branch_4",
				"seapay_branch_5",
			],
			diving: ["section_diving_general", "section_diving_class", "section_diving_officer", "section_diving_navy", "section_diving_eod"],
			aviation: ["section_aviation_af_flyers", "section_aviation_career", "section_aviation_af_aviation", "section_aviation_navy_flyers", "section_aviation_hdip"],
			summary: ["section_summary"],
			generate: ["section_generate_readiness"],
		};

		function isSectionCollapsed(sectionId: string): boolean {
			let state = collapsedSectionsObservable();
			return !!state[sectionId];
		}

		function toggleSection(sectionId: string): void {
			let state = Object.assign({}, collapsedSectionsObservable());
			state[sectionId] = !state[sectionId];
			collapsedSectionsObservable(state);
		}

		function expandAllSectionsBound(): void {
			let vm = self.getTemplateViewModel();
			if (!vm) return;
			let ids = SECTIONS_BY_TAB[vm.activeTab()];
			if (!ids || ids.length === 0) return;
			let state = Object.assign({}, collapsedSectionsObservable());
			for (let id of ids) state[id] = false;
			collapsedSectionsObservable(state);
		}

		function collapseAllSectionsBound(): void {
			let vm = self.getTemplateViewModel();
			if (!vm) return;
			let ids = SECTIONS_BY_TAB[vm.activeTab()];
			if (!ids || ids.length === 0) return;
			let state = Object.assign({}, collapsedSectionsObservable());
			for (let id of ids) state[id] = true;
			collapsedSectionsObservable(state);
		}

		function hasCollapsibleSections(): boolean {
			let vm = self.getTemplateViewModel();
			if (!vm) return false;
			vm.activeTab(); // create dependency so computed re-runs when tab changes
			let ids = SECTIONS_BY_TAB[vm.activeTab()];
			return !!(ids && ids.length > 0);
		}

		// ——— Sea Pay Matrix structured editor ———
		type SeaPayEditorRow = { id: number; branch: string; paygrade: any; yearsOfSeaDuty: any; value: any };
		let seaPayMatrixEditorRowsByBranch: Record<string, { (): SeaPayEditorRow[]; (val: SeaPayEditorRow[]): void }> = {} as any;
		for (const bid of SEAPAY_BRANCH_IDS) {
			seaPayMatrixEditorRowsByBranch[bid] = ko.observableArray([]);
		}
		let seaPayMatrixNextId = 1;

		function makeSeaPayEditorRow(id: number, branchId: string, paygrade: number, yearsOfSeaDuty: number | null, value: number): SeaPayEditorRow {
			const branchName = SEAPAY_BRANCH_ID_TO_API_NAME[branchId] || "MARINE_CORPS";
			return {
				id,
				branch: branchName,
				paygrade: ko.observable(paygrade),
				yearsOfSeaDuty: ko.observable(yearsOfSeaDuty),
				value: ko.observable(value),
			};
		}

		function getNextSeaPayRowId(): number {
			let max = seaPayMatrixNextId - 1;
			for (const bid of SEAPAY_BRANCH_IDS) {
				const rows = seaPayMatrixEditorRowsByBranch[bid]();
				for (const r of rows) if (r.id > max) max = r.id;
			}
			seaPayMatrixNextId = max + 2;
			return max + 1;
		}

		function hydrateSeaPayMatrixFromJson(data: Record<string, Array<{ id?: number; branch?: string; value?: number; paygrade?: number; yearsOfSeaDuty?: number | null }>> | null | undefined): void {
			if (!data || typeof data !== "object" || Array.isArray(data)) return;
			let maxId = 0;
			for (const bid of SEAPAY_BRANCH_IDS) {
				const arr = data[bid];
				if (!Array.isArray(arr)) continue;
				const branchName = SEAPAY_BRANCH_ID_TO_API_NAME[bid] || "MARINE_CORPS";
				const editorRows: SeaPayEditorRow[] = arr.map((row) => {
					const id = typeof row.id === "number" ? row.id : ++maxId;
					if (id > maxId) maxId = id;
					return makeSeaPayEditorRow(
						id,
						bid,
						typeof row.paygrade === "number" ? row.paygrade : 0,
						row.yearsOfSeaDuty != null && typeof row.yearsOfSeaDuty === "number" ? row.yearsOfSeaDuty : null,
						typeof row.value === "number" ? row.value : 0,
					);
				});
				seaPayMatrixEditorRowsByBranch[bid](editorRows);
			}
			if (maxId >= seaPayMatrixNextId) seaPayMatrixNextId = maxId + 1;
		}

		function serializeSeaPayMatrixFromEditor(): Record<string, Array<{ id: number; branch: string; value: number; paygrade: number; yearsOfSeaDuty: number | null }>> {
			const out: Record<string, Array<{ id: number; branch: string; value: number; paygrade: number; yearsOfSeaDuty: number | null }>> = {};
			for (const bid of SEAPAY_BRANCH_IDS) {
				const rows = seaPayMatrixEditorRowsByBranch[bid]();
				out[bid] = rows.map((r) => ({
					id: r.id,
					branch: r.branch,
					paygrade: typeof r.paygrade() === "number" ? r.paygrade() : 0,
					yearsOfSeaDuty: r.yearsOfSeaDuty() != null && typeof r.yearsOfSeaDuty() === "number" ? r.yearsOfSeaDuty() : null,
					value: typeof r.value() === "number" ? r.value() : 0,
				}));
			}
			return out;
		}

		function getSeaPayMatrixEditorSummary(): { branchCount: number; totalRows: number; rowsByBranch: Record<string, number> } {
			let totalRows = 0;
			const rowsByBranch: Record<string, number> = {};
			for (const bid of SEAPAY_BRANCH_IDS) {
				const n = seaPayMatrixEditorRowsByBranch[bid]().length;
				rowsByBranch[bid] = n;
				totalRows += n;
			}
			const branchCount = SEAPAY_BRANCH_IDS.filter((bid) => seaPayMatrixEditorRowsByBranch[bid]().length > 0).length;
			return { branchCount, totalRows, rowsByBranch };
		}

		function addSeaPayRow(branchId: string): void {
			const bid = String(branchId);
			const obs = seaPayMatrixEditorRowsByBranch[bid];
			if (typeof obs !== "function") return;
			const branchName = SEAPAY_BRANCH_ID_TO_API_NAME[bid] || "MARINE_CORPS";
			const arr = obs();
			arr.push(makeSeaPayEditorRow(getNextSeaPayRowId(), bid, 0, null, 0));
			obs(arr);
		}

		function duplicateSeaPayRow(branchId: string, row: SeaPayEditorRow): void {
			const bid = String(branchId);
			const obs = seaPayMatrixEditorRowsByBranch[bid];
			if (typeof obs !== "function") return;
			const arr = obs().slice();
			const idx = arr.indexOf(row);
			const copy = makeSeaPayEditorRow(
				getNextSeaPayRowId(),
				bid,
				typeof row.paygrade() === "number" ? row.paygrade() : 0,
				row.yearsOfSeaDuty() != null && typeof row.yearsOfSeaDuty() === "number" ? row.yearsOfSeaDuty() : null,
				typeof row.value() === "number" ? row.value() : 0,
			);
			arr.splice(idx + 1, 0, copy);
			obs(arr);
		}

		function removeSeaPayRow(branchId: string, row: SeaPayEditorRow): void {
			const bid = String(branchId);
			const obs = seaPayMatrixEditorRowsByBranch[bid];
			if (typeof obs !== "function") return;
			const arr = obs().filter((r) => r !== row);
			obs(arr);
		}

		function resetSeaPayBranch(branchId: string): void {
			const bid = String(branchId);
			const obs = seaPayMatrixEditorRowsByBranch[bid];
			if (typeof obs === "function") obs([]);
		}

		const seaPayMatrixEditorSummaryStatus = ko.pureComputed(() => (getSeaPayMatrixEditorSummary().totalRows > 0 ? "Loaded" : "Empty"));
		const seaPayMatrixEditorSummaryCount = ko.pureComputed(() => {
			const s = getSeaPayMatrixEditorSummary();
			return s.totalRows > 0 ? s.branchCount + " branches, " + s.totalRows + " rows" : "0";
		});

		type SubmarinePayEditorRow = { id: number; paygrade: any; yearsOfSubmarineExperience: any; value: any };
		let submarinePayEditorRows = ko.observableArray([]);
		let submarinePayNextId = 1;

		function makeSubmarinePayEditorRow(id: number, paygrade: number, yearsOfSubmarineExperience: number | null, value: number): SubmarinePayEditorRow {
			return {
				id,
				paygrade: ko.observable(paygrade),
				yearsOfSubmarineExperience: ko.observable(yearsOfSubmarineExperience),
				value: ko.observable(value),
			};
		}

		function getNextSubmarinePayRowId(): number {
			let max = submarinePayNextId - 1;
			const rows = submarinePayEditorRows();
			for (const r of rows) if (r.id > max) max = r.id;
			submarinePayNextId = max + 2;
			return max + 1;
		}

		function hydrateSubmarinePayFromJson(data: Array<{ id?: number; value?: number; paygrade?: number; yearsOfSubmarineExperience?: number | null }> | null | undefined): void {
			if (!Array.isArray(data)) return;
			let maxId = 0;
			const editorRows: SubmarinePayEditorRow[] = data.map((row) => {
				const id = typeof row.id === "number" ? row.id : ++maxId;
				if (id > maxId) maxId = id;
				return makeSubmarinePayEditorRow(
					id,
					typeof row.paygrade === "number" ? row.paygrade : 0,
					row.yearsOfSubmarineExperience != null && typeof row.yearsOfSubmarineExperience === "number" ? row.yearsOfSubmarineExperience : null,
					typeof row.value === "number" ? row.value : 0,
				);
			});
			submarinePayEditorRows(editorRows);
			if (maxId >= submarinePayNextId) submarinePayNextId = maxId + 1;
		}

		function serializeSubmarinePayFromEditor(): Array<{ id: number; value: number; paygrade: number; yearsOfSubmarineExperience: number | null }> {
			return submarinePayEditorRows().map((r: SubmarinePayEditorRow) => ({
				id: r.id,
				paygrade: typeof r.paygrade() === "number" ? r.paygrade() : 0,
				yearsOfSubmarineExperience: r.yearsOfSubmarineExperience() != null && typeof r.yearsOfSubmarineExperience() === "number" ? r.yearsOfSubmarineExperience() : null,
				value: typeof r.value() === "number" ? r.value() : 0,
			}));
		}

		function getSubmarinePayEditorSummary(): { totalRows: number } {
			return { totalRows: submarinePayEditorRows().length };
		}

		function addSubmarinePayRow(): void {
			const arr = submarinePayEditorRows().slice();
			arr.push(makeSubmarinePayEditorRow(getNextSubmarinePayRowId(), 0, null, 0));
			submarinePayEditorRows(arr);
		}

		function duplicateSubmarinePayRow(row: SubmarinePayEditorRow): void {
			const arr = submarinePayEditorRows().slice();
			const idx = arr.indexOf(row);
			const copy = makeSubmarinePayEditorRow(
				getNextSubmarinePayRowId(),
				typeof row.paygrade() === "number" ? row.paygrade() : 0,
				row.yearsOfSubmarineExperience() != null && typeof row.yearsOfSubmarineExperience() === "number" ? row.yearsOfSubmarineExperience() : null,
				typeof row.value() === "number" ? row.value() : 0,
			);
			arr.splice(idx + 1, 0, copy);
			submarinePayEditorRows(arr);
		}

		function removeSubmarinePayRow(row: SubmarinePayEditorRow): void {
			submarinePayEditorRows(submarinePayEditorRows().filter((r: SubmarinePayEditorRow) => r !== row));
		}

		function resetSubmarinePay(): void {
			submarinePayEditorRows([]);
		}

		const submarinePayEditorSummaryStatus = ko.pureComputed(() => (getSubmarinePayEditorSummary().totalRows > 0 ? "Loaded" : "Empty"));
		const submarinePayEditorSummaryCount = ko.pureComputed(() => {
			const s = getSubmarinePayEditorSummary();
			return s.totalRows > 0 ? s.totalRows + " rows" : "0";
		});

		type AwacsPayEditorRow = { id: number; paygrade: any; yearsOfDuty: any; value: any };
		let awacsPayEditorRows = ko.observableArray([]);
		let awacsPayNextId = 1;

		function makeAwacsPayEditorRow(id: number, paygrade: number, yearsOfDuty: number, value: number): AwacsPayEditorRow {
			return {
				id,
				paygrade: ko.observable(paygrade),
				yearsOfDuty: ko.observable(yearsOfDuty),
				value: ko.observable(value),
			};
		}

		function getNextAwacsPayRowId(): number {
			let max = awacsPayNextId - 1;
			const rows = awacsPayEditorRows();
			for (const r of rows) if (r.id > max) max = r.id;
			awacsPayNextId = max + 2;
			return max + 1;
		}

		function hydrateAwacsPayFromJson(data: Array<{ id?: number; value?: number; paygrade?: number; yearsOfDuty?: number }> | null | undefined): void {
			if (!Array.isArray(data)) return;
			let maxId = 0;
			const editorRows: AwacsPayEditorRow[] = data.map((row) => {
				const id = typeof row.id === "number" ? row.id : ++maxId;
				if (id > maxId) maxId = id;
				return makeAwacsPayEditorRow(id, typeof row.paygrade === "number" ? row.paygrade : 0, typeof row.yearsOfDuty === "number" ? row.yearsOfDuty : 1, typeof row.value === "number" ? row.value : 0);
			});
			awacsPayEditorRows(editorRows);
			if (maxId >= awacsPayNextId) awacsPayNextId = maxId + 1;
		}

		function serializeAwacsPayFromEditor(): Array<{ id: number; value: number; paygrade: number; yearsOfDuty: number }> {
			return awacsPayEditorRows().map((r: AwacsPayEditorRow) => ({
				id: r.id,
				paygrade: typeof r.paygrade() === "number" ? r.paygrade() : 0,
				yearsOfDuty: typeof r.yearsOfDuty() === "number" ? r.yearsOfDuty() : 1,
				value: typeof r.value() === "number" ? r.value() : 0,
			}));
		}

		function getAwacsPayEditorSummary(): { totalRows: number } {
			return { totalRows: awacsPayEditorRows().length };
		}

		function addAwacsPayRow(): void {
			const arr = awacsPayEditorRows().slice();
			arr.push(makeAwacsPayEditorRow(getNextAwacsPayRowId(), 0, 1, 0));
			awacsPayEditorRows(arr);
		}

		function duplicateAwacsPayRow(row: AwacsPayEditorRow): void {
			const arr = awacsPayEditorRows().slice();
			const idx = arr.indexOf(row);
			const copy = makeAwacsPayEditorRow(
				getNextAwacsPayRowId(),
				typeof row.paygrade() === "number" ? row.paygrade() : 0,
				typeof row.yearsOfDuty() === "number" ? row.yearsOfDuty() : 1,
				typeof row.value() === "number" ? row.value() : 0,
			);
			arr.splice(idx + 1, 0, copy);
			awacsPayEditorRows(arr);
		}

		function removeAwacsPayRow(row: AwacsPayEditorRow): void {
			awacsPayEditorRows(awacsPayEditorRows().filter((r: AwacsPayEditorRow) => r !== row));
		}

		function resetAwacsPay(): void {
			awacsPayEditorRows([]);
		}

		const awacsPayEditorSummaryStatus = ko.pureComputed(() => (getAwacsPayEditorSummary().totalRows > 0 ? "Loaded" : "Empty"));
		const awacsPayEditorSummaryCount = ko.pureComputed(() => {
			const s = getAwacsPayEditorSummary();
			return s.totalRows > 0 ? s.totalRows + " rows" : "0";
		});

		type CboHDPEditorRow = { id: number; name: any; value: any };
		let cboHDPEditorRows = ko.observableArray([]);
		let cboHDPNextId = 1;

		function makeCboHDPEditorRow(id: number, name: string, value: number | null): CboHDPEditorRow {
			return {
				id,
				name: ko.observable(name),
				value: ko.observable(value),
			};
		}

		function getNextCboHDPRowId(): number {
			let max = cboHDPNextId - 1;
			const rows = cboHDPEditorRows();
			for (const r of rows) if (r.id > max) max = r.id;
			cboHDPNextId = max + 2;
			return max + 1;
		}

		function hydrateCboHDPFromJson(data: Array<{ id?: number; value?: number | null; name?: string }> | null | undefined): void {
			if (!Array.isArray(data)) return;
			let maxId = 0;
			const editorRows: CboHDPEditorRow[] = data.map((row) => {
				const id = typeof row.id === "number" ? row.id : ++maxId;
				if (id > maxId) maxId = id;
				return makeCboHDPEditorRow(id, typeof row.name === "string" ? row.name : "", row.value == null ? null : typeof row.value === "number" ? row.value : null);
			});
			cboHDPEditorRows(editorRows);
			if (maxId >= cboHDPNextId) cboHDPNextId = maxId + 1;
		}

		function serializeCboHDPFromEditor(): Array<{ id: number; value: number | null; name: string }> {
			return cboHDPEditorRows().map((r: CboHDPEditorRow) => {
				const rawValue = r.value();
				return {
					id: r.id,
					name: typeof r.name() === "string" ? r.name() : "",
					value: rawValue == null || rawValue === "" ? null : typeof rawValue === "number" ? rawValue : null,
				};
			});
		}

		function getCboHDPEditorSummary(): { totalRows: number } {
			return { totalRows: cboHDPEditorRows().length };
		}

		function addCboHDPRow(): void {
			const arr = cboHDPEditorRows().slice();
			arr.push(makeCboHDPEditorRow(getNextCboHDPRowId(), "", 0));
			cboHDPEditorRows(arr);
		}

		function duplicateCboHDPRow(row: CboHDPEditorRow): void {
			const arr = cboHDPEditorRows().slice();
			const idx = arr.indexOf(row);
			const copy = makeCboHDPEditorRow(
				getNextCboHDPRowId(),
				typeof row.name() === "string" ? row.name() : "",
				row.value() == null || row.value() === "" ? null : typeof row.value() === "number" ? row.value() : null,
			);
			arr.splice(idx + 1, 0, copy);
			cboHDPEditorRows(arr);
		}

		function removeCboHDPRow(row: CboHDPEditorRow): void {
			cboHDPEditorRows(cboHDPEditorRows().filter((r: CboHDPEditorRow) => r !== row));
		}

		function resetCboHDP(): void {
			cboHDPEditorRows([]);
		}

		const cboHDPEditorSummaryStatus = ko.pureComputed(() => (getCboHDPEditorSummary().totalRows > 0 ? "Loaded" : "Empty"));
		const cboHDPEditorSummaryCount = ko.pureComputed(() => {
			const s = getCboHDPEditorSummary();
			return s.totalRows > 0 ? s.totalRows + " rows" : "0";
		});

		type CboDivingPayEditorRow = { id: number; name: any; value: any };
		let cboDivingPayEditorRows = ko.observableArray([]);
		let cboDivingPayNextId = 1;

		function makeCboDivingPayEditorRow(id: number, name: string, value: number): CboDivingPayEditorRow {
			return {
				id,
				name: ko.observable(name),
				value: ko.observable(value),
			};
		}

		function getNextCboDivingPayRowId(): number {
			let max = cboDivingPayNextId - 1;
			const rows = cboDivingPayEditorRows();
			for (const r of rows) if (r.id > max) max = r.id;
			cboDivingPayNextId = max + 2;
			return max + 1;
		}

		function hydrateCboDivingPayFromJson(data: Array<{ id?: number; value?: number; name?: string }> | null | undefined): void {
			if (!Array.isArray(data)) return;
			let maxId = 0;
			const editorRows: CboDivingPayEditorRow[] = data.map((row) => {
				const id = typeof row.id === "number" ? row.id : ++maxId;
				if (id > maxId) maxId = id;
				return makeCboDivingPayEditorRow(id, typeof row.name === "string" ? row.name : "", typeof row.value === "number" ? row.value : 0);
			});
			cboDivingPayEditorRows(editorRows);
			if (maxId >= cboDivingPayNextId) cboDivingPayNextId = maxId + 1;
		}

		function serializeCboDivingPayFromEditor(): Array<{ id: number; value: number; name: string }> {
			return cboDivingPayEditorRows().map((r: CboDivingPayEditorRow) => ({
				id: r.id,
				name: typeof r.name() === "string" ? r.name() : "",
				value: typeof r.value() === "number" ? r.value() : 0,
			}));
		}

		function getCboDivingPayEditorSummary(): { totalRows: number } {
			return { totalRows: cboDivingPayEditorRows().length };
		}

		function addCboDivingPayRow(): void {
			const arr = cboDivingPayEditorRows().slice();
			arr.push(makeCboDivingPayEditorRow(getNextCboDivingPayRowId(), "", 0));
			cboDivingPayEditorRows(arr);
		}

		function duplicateCboDivingPayRow(row: CboDivingPayEditorRow): void {
			const arr = cboDivingPayEditorRows().slice();
			const idx = arr.indexOf(row);
			const copy = makeCboDivingPayEditorRow(getNextCboDivingPayRowId(), typeof row.name() === "string" ? row.name() : "", typeof row.value() === "number" ? row.value() : 0);
			arr.splice(idx + 1, 0, copy);
			cboDivingPayEditorRows(arr);
		}

		function removeCboDivingPayRow(row: CboDivingPayEditorRow): void {
			cboDivingPayEditorRows(cboDivingPayEditorRows().filter((r: CboDivingPayEditorRow) => r !== row));
		}

		function resetCboDivingPay(): void {
			cboDivingPayEditorRows([]);
		}

		const cboDivingPayEditorSummaryStatus = ko.pureComputed(() => (getCboDivingPayEditorSummary().totalRows > 0 ? "Loaded" : "Empty"));
		const cboDivingPayEditorSummaryCount = ko.pureComputed(() => {
			const s = getCboDivingPayEditorSummary();
			return s.totalRows > 0 ? s.totalRows + " rows" : "0";
		});

		return {
			activeTab: ko.observable("uploads"),
			statusText: ko.pureComputed(function () {
				return saveStatus();
			}),

			// Collapsible sections
			collapsedSectionsObservable: collapsedSectionsObservable,
			isSectionCollapsed: function (sectionId: string) {
				return isSectionCollapsed(sectionId);
			},
			toggleSection: function (sectionId: string) {
				toggleSection(sectionId);
			},
			expandAllSections: expandAllSectionsBound,
			collapseAllSections: collapseAllSectionsBound,
			hasCollapsibleSections: ko.pureComputed(hasCollapsibleSections),

			// Upload statuses
			bahRatesStatus: ko.observable("Not Uploaded"),
			zipCodeMappingStatus: ko.observable("Not Uploaded"),
			colaZipsStatus: ko.observable("Not Uploaded"),
			colaWithDepsStatus: ko.observable("Not Uploaded"),
			colaWithoutDepsStatus: ko.observable("Not Uploaded"),
			activeDutyPayStatus: ko.observable("Not Uploaded"),
			drillPayStatus: ko.observable("Not Uploaded"),

			// Upload counts
			bahRatesCount: ko.observable(0),
			cboZipCount: ko.observable(0),
			zipCodeMappingCount: ko.observable(0),
			colaZipsCount: ko.observable(0),
			colaWithDepsCount: ko.observable(0),
			colaWithoutDepsCount: ko.observable(0),
			activeDutyPayCount: ko.observable(0),
			drillPayCount: ko.observable(0),

			// General settings
			payCalculatorYear: ko.observable(new Date().getFullYear()),
			bahRateYear: ko.observable(new Date().getFullYear()),
			activeDutyPayChartUrl: ko.observable(""),
			drillPayPaychartUrl: ko.observable(""),
			bahRateWithDependantUrl: ko.observable(""),
			bahRateWithoutDependantUrl: ko.observable(""),

			// Subsistence allowance
			substistanceAllowancePayList: basSubList,

			// Hazardous duty pay
			imminentDangerPay: ko.observable(225),
			hostilePay: ko.observable(225),
			demolitionPay: ko.observable(150),
			jumpPay: ko.observable(150),
			haloPay: ko.observable(225),
			flightDeckDutyPay: ko.observable(150),
			hazardPayNonCrewmemberPay: ko.observable(150),

			// Special allowance pay
			singleForeignLanguagePay: ko.observable(500),
			multipleForeignLanguagePay: ko.observable(1000),
			extendedDutySpecialPay: ko.observable(80),
			separationPay: ko.observable(250),
			assymetricWarfarePay: ko.observable(400),
			militaryIntelligencePay: ko.observable(300),
			commandSergeantMajorPay: ko.observable(1250),

			// Coast Guard
			msstTacletLeaderPay: ko.observable(75),
			cgDiverPay: ko.observable(150),
			rescueSwimmerPay: ko.observable(225),
			surfmanPay: ko.observable(300),

			// Special Missions
			specialMissionsPay1: ko.observable(750),
			specialMissionsPay2: ko.observable(1000),

			// General Diving
			masterDiverPay: ko.observable(340),
			salvageDiverPay: ko.observable(175),
			combatantDiverPay: ko.observable(215),
			combatDiverPay: ko.observable(215),
			paraRescueDiverPay: ko.observable(150),

			// Diver class pay by branch
			diverFirstClassPay3: ko.observable(215),
			diverFirstClassPay4: ko.observable(315),
			diverSecondClassPay3: ko.observable(150),
			diverSecondClassPay4: ko.observable(215),

			// Diving officer & scuba
			divingOfficerPay2: ko.observable(150),
			divingOfficerPay3: ko.observable(240),
			scubaPay2: ko.observable(110),
			scubaPay4: ko.observable(150),

			// Navy diving
			combatantSwimmerNavyPay: ko.observable(215),
			basicCombatantSwimmerNavyPay: ko.observable(150),
			masterUCTDiverNavyPay: ko.observable(340),
			advancedUCTDiverNavyPay: ko.observable(215),
			basicUCTDiverNavyPay: ko.observable(150),
			scubaDiverNavyPay: ko.observable(150),
			medicalDivingTechNavyPay: ko.observable(215),
			medicalDiverSaturationNavyPay: ko.observable(315),
			diverInTrainingNavyPay: ko.observable(150),
			saturationDiverNavyPay: ko.observable(315),
			sealDeliveryVehiclePilotNavyPay: ko.observable(340),
			specialWarfareOperatorNavyPay: ko.observable(215),
			medicalSpecialOpsTechNavyPay: ko.observable(215),
			specReconFleetCorpsmanNavyPay: ko.observable(215),
			medicalDivingOfficerNavyPay: ko.observable(240),
			divingCWONavyPay: ko.observable(240),
			specialWarfareOfficerNavyPay: ko.observable(240),

			// EOD
			eodDiverNavyPay: ko.observable(150),
			eodAssistantNavyPay: ko.observable(150),
			basicEODTechDiverNavyPay: ko.observable(215),
			srEodTechDiverNavyPay: ko.observable(215),
			masterEODTechNavyPay: ko.observable(215),
			eodOfficerNavyPay: ko.observable(240),
			eodPayList: eodPayList,

			// Aviation
			airForceEnlistedPayList: airForceEnlistedPayList,
			aviationExperiencePayList: aviationExperiencePayList,
			airForceAviationExperiencePayList: airForceAviationExperiencePayList,
			navyEnlistedPayList: navyEnlistedPayList,
			hazardPayHDIPList: hazardPayHDIPList,

			// Complex data (loaded from files)
			basePayMatrixData: ko.observable(null),
			seaPayMatrixData: ko.observable(null),
			housingAllowanceData: ko.observable(null),
			submarinePayData: ko.observable(null),
			awacsPayData: ko.observable(null),
			cboHDPData: ko.observable(null),
			cboDivingPayData: ko.observable(null),
			// Manual JSON paste (data not from uploads)
			seaPayMatrixJson: ko.observable(""),
			// Sea Pay Matrix structured editor (source of truth for UI; serialized in generateJson)
			seaPayMatrixEditorRowsByBranch: seaPayMatrixEditorRowsByBranch,
			seaPayMatrixBranchIds: SEAPAY_BRANCH_IDS,
			seaPayMatrixBranchLabel: function (branchId: string) {
				const opt = BRANCH_OPTIONS.find((o) => String((o as any).value) === branchId);
				return opt ? (opt as any).name : branchId;
			},
			seaPayMatrixPaygradeOptions: PAYGRADE_OPTIONS,
			seaPayMatrixYearsOptions: YEARS_OF_SEA_DUTY_OPTIONS_WITH_NULL,
			addSeaPayRow: function (branchId: string) {
				addSeaPayRow(branchId);
			},
			duplicateSeaPayRow: function (branchId: string, row: SeaPayEditorRow) {
				duplicateSeaPayRow(branchId, row);
			},
			removeSeaPayRow: function (branchId: string, row: SeaPayEditorRow) {
				removeSeaPayRow(branchId, row);
			},
			resetSeaPayBranch: function (branchId: string) {
				resetSeaPayBranch(branchId);
			},
			getSeaPayMatrixEditorSummary: getSeaPayMatrixEditorSummary,
			seaPayMatrixEditorSummaryStatus: seaPayMatrixEditorSummaryStatus,
			seaPayMatrixEditorSummaryCount: seaPayMatrixEditorSummaryCount,
			hydrateSeaPayMatrixFromJson: function () {
				const raw = (this as any).seaPayMatrixJson ? (this as any).seaPayMatrixJson() : "";
				const fromData = (this as any).seaPayMatrixData ? (this as any).seaPayMatrixData() : null;
				let obj: any = null;
				if (raw && typeof raw === "string" && raw.trim()) {
					try {
						obj = JSON.parse(raw.trim());
					} catch (_e) {
						obj = null;
					}
				}
				if (!obj || typeof obj !== "object" || Array.isArray(obj)) obj = fromData;
				hydrateSeaPayMatrixFromJson(obj);
			},
			serializeSeaPayMatrixFromEditor: serializeSeaPayMatrixFromEditor,
			submarinePayEditorRows: submarinePayEditorRows,
			submarinePayPaygradeOptions: PAYGRADE_OPTIONS,
			submarinePayYearsOptions: YEARS_OF_SUBMARINE_EXPERIENCE_OPTIONS_WITH_NULL,
			addSubmarinePayRow: function () {
				addSubmarinePayRow();
			},
			duplicateSubmarinePayRow: function (row: SubmarinePayEditorRow) {
				duplicateSubmarinePayRow(row);
			},
			removeSubmarinePayRow: function (row: SubmarinePayEditorRow) {
				removeSubmarinePayRow(row);
			},
			resetSubmarinePay: function () {
				resetSubmarinePay();
			},
			getSubmarinePayEditorSummary: getSubmarinePayEditorSummary,
			submarinePayEditorSummaryStatus: submarinePayEditorSummaryStatus,
			submarinePayEditorSummaryCount: submarinePayEditorSummaryCount,
			hydrateSubmarinePayFromJson: function () {
				const raw = (this as any).submarinePayJson ? (this as any).submarinePayJson() : "";
				const fromData = (this as any).submarinePayData ? (this as any).submarinePayData() : null;
				let obj: any = null;
				if (raw && typeof raw === "string" && raw.trim()) {
					try {
						obj = JSON.parse(raw.trim());
					} catch (_e) {
						obj = null;
					}
				}
				if (!Array.isArray(obj)) obj = fromData;
				hydrateSubmarinePayFromJson(obj);
			},
			serializeSubmarinePayFromEditor: serializeSubmarinePayFromEditor,
			submarinePayJson: ko.observable(""),
			awacsPayEditorRows: awacsPayEditorRows,
			awacsPayPaygradeOptions: PAYGRADE_OPTIONS,
			awacsPayYearsOptions: YEARS_OF_HAZARDOUS_DUTY_AWACS_OPTIONS,
			addAwacsPayRow: function () {
				addAwacsPayRow();
			},
			duplicateAwacsPayRow: function (row: AwacsPayEditorRow) {
				duplicateAwacsPayRow(row);
			},
			removeAwacsPayRow: function (row: AwacsPayEditorRow) {
				removeAwacsPayRow(row);
			},
			resetAwacsPay: function () {
				resetAwacsPay();
			},
			getAwacsPayEditorSummary: getAwacsPayEditorSummary,
			awacsPayEditorSummaryStatus: awacsPayEditorSummaryStatus,
			awacsPayEditorSummaryCount: awacsPayEditorSummaryCount,
			hydrateAwacsPayFromJson: function () {
				const raw = (this as any).awacsPayJson ? (this as any).awacsPayJson() : "";
				const fromData = (this as any).awacsPayData ? (this as any).awacsPayData() : null;
				let obj: any = null;
				if (raw && typeof raw === "string" && raw.trim()) {
					try {
						obj = JSON.parse(raw.trim());
					} catch (_e) {
						obj = null;
					}
				}
				if (!Array.isArray(obj)) obj = fromData;
				hydrateAwacsPayFromJson(obj);
			},
			serializeAwacsPayFromEditor: serializeAwacsPayFromEditor,
			awacsPayJson: ko.observable(""),
			cboHDPEditorRows: cboHDPEditorRows,
			addCboHDPRow: function () {
				addCboHDPRow();
			},
			duplicateCboHDPRow: function (row: CboHDPEditorRow) {
				duplicateCboHDPRow(row);
			},
			removeCboHDPRow: function (row: CboHDPEditorRow) {
				removeCboHDPRow(row);
			},
			resetCboHDP: function () {
				resetCboHDP();
			},
			getCboHDPEditorSummary: getCboHDPEditorSummary,
			cboHDPEditorSummaryStatus: cboHDPEditorSummaryStatus,
			cboHDPEditorSummaryCount: cboHDPEditorSummaryCount,
			hydrateCboHDPFromJson: function () {
				const raw = (this as any).cboHDPJson ? (this as any).cboHDPJson() : "";
				const fromData = (this as any).cboHDPData ? (this as any).cboHDPData() : null;
				let obj: any = null;
				if (raw && typeof raw === "string" && raw.trim()) {
					try {
						obj = JSON.parse(raw.trim());
					} catch (_e) {
						obj = null;
					}
				}
				if (!Array.isArray(obj)) obj = fromData;
				hydrateCboHDPFromJson(obj);
			},
			serializeCboHDPFromEditor: serializeCboHDPFromEditor,
			cboHDPJson: ko.observable(""),
			cboDivingPayEditorRows: cboDivingPayEditorRows,
			addCboDivingPayRow: function () {
				addCboDivingPayRow();
			},
			duplicateCboDivingPayRow: function (row: CboDivingPayEditorRow) {
				duplicateCboDivingPayRow(row);
			},
			removeCboDivingPayRow: function (row: CboDivingPayEditorRow) {
				removeCboDivingPayRow(row);
			},
			resetCboDivingPay: function () {
				resetCboDivingPay();
			},
			getCboDivingPayEditorSummary: getCboDivingPayEditorSummary,
			cboDivingPayEditorSummaryStatus: cboDivingPayEditorSummaryStatus,
			cboDivingPayEditorSummaryCount: cboDivingPayEditorSummaryCount,
			hydrateCboDivingPayFromJson: function () {
				const raw = (this as any).cboDivingPayJson ? (this as any).cboDivingPayJson() : "";
				const fromData = (this as any).cboDivingPayData ? (this as any).cboDivingPayData() : null;
				let obj: any = null;
				if (raw && typeof raw === "string" && raw.trim()) {
					try {
						obj = JSON.parse(raw.trim());
					} catch (_e) {
						obj = null;
					}
				}
				if (!Array.isArray(obj)) obj = fromData;
				hydrateCboDivingPayFromJson(obj);
			},
			serializeCboDivingPayFromEditor: serializeCboDivingPayFromEditor,
			cboDivingPayJson: ko.observable(""),
			cboZipData: ko.observable(null),
			colaBasePayWithDepsData: ko.observable(null),
			colaBasePayWithoutDepsData: ko.observable(null),
			zipCode2DutyStationData: ko.observable(null),
			colaRateWithDependantData: ko.observable(null),

			// Generation
			generatedJson: ko.observable(null),
			jsonPreview: ko.observable(""),

			// File handlers
			handleBahRatesUpload: function (data: any, event: any) {
				self.handleBahRatesUpload(event);
			},
			handleZipCodeMappingUpload: function (data: any, event: any) {
				self.handleZipCodeMappingUpload(event);
			},
			handleColaZipsUpload: function (data: any, event: any) {
				self.handleColaZipsUpload(event);
			},
			handleColaWithDepsUpload: function (data: any, event: any) {
				self.handleColaWithDepsUpload(event);
			},
			handleColaWithoutDepsUpload: function (data: any, event: any) {
				self.handleColaWithoutDepsUpload(event);
			},
			handleActiveDutyPayUpload: function (data: any, event: any) {
				self.handleActiveDutyPayUpload(event);
			},
			handleDrillPayUpload: function (data: any, event: any) {
				self.handleDrillPayUpload(event);
			},
			generateJson: function () {
				self.generateJson();
			},
			downloadJson: function () {
				self.downloadJson();
			},
			saveStatus: saveStatus,
			save: function () {
				self.save();
			},
		};
	}

	protected getTemplateName(): string {
		return "militaryPayCalculator_template";
	}

	// ==================== FILE PARSING METHODS ====================

	private vm(): any {
		return this.getTemplateViewModel();
	}

	private paygradeValueToName(val: number): string {
		for (let name in PAYGRADE_MAP) {
			if (PAYGRADE_MAP[name] === val) return name;
		}
		return "";
	}

	private unwrapObservable(value: any): any {
		return typeof value === "function" ? value() : value;
	}

	private toMoney(value: any): number {
		let parsed = parseFloat(value);
		if (isNaN(parsed)) return 0;
		return Math.round(parsed * 100) / 100;
	}

	private cloneNameValueList(items: Array<{ value: number | string; name: string }>): any[] {
		return items.map((item) => ({ value: item.value, name: item.name }));
	}

	private normalizeStringNameValueList(items: any): any[] {
		if (!Array.isArray(items)) return [];
		return items
			.filter((item: any) => item && item.value != null && item.name != null)
			.map((item: any) => ({
				value: String(item.value),
				name: String(item.name),
			}));
	}

	private normalizePaygradeYearValueList(items: any, yearKey: string = "yearsOfService"): any[] {
		if (!Array.isArray(items)) return [];
		return items
			.filter((item: any) => item != null)
			.map((item: any) => {
				let normalized: any = {
					paygrade: parseInt(item.paygrade, 10) || 0,
					value: this.toMoney(item.value),
				};
				normalized[yearKey] = parseInt(item[yearKey], 10) || 0;
				return normalized;
			});
	}

	private normalizeBasePayEntries(items: any): any[] {
		if (!Array.isArray(items)) return [];
		return items
			.filter((item: any) => item != null)
			.map((item: any) => {
				let normalized: any = {
					paygrade: parseInt(item.paygrade, 10) || 0,
					yearsOfService: parseInt(item.yearsOfService, 10) || 0,
					value: this.toMoney(item.value),
				};
				if (item.drillPay4Month != null && item.drillPay4Month !== "") {
					normalized.drillPay4Month = this.toMoney(item.drillPay4Month);
				}
				return normalized;
			});
	}

	private buildAmountNameValueList(items: any): any[] {
		if (!Array.isArray(items)) return [];
		return items.map((item: any) => ({
			value: this.toMoney(this.unwrapObservable(item.value)),
			name: String(item.label || item.name || ""),
		}));
	}

	private buildKeyedAmountMap(items: any): Record<string, number> {
		let output: Record<string, number> = {};
		if (!Array.isArray(items)) return output;
		for (let item of items) {
			if (!item || item.key == null) continue;
			output[String(item.key)] = this.toMoney(this.unwrapObservable(item.value));
		}
		return output;
	}

	private parseSavedPayload(payload: any): any {
		if (payload == null) return null;
		if (typeof payload === "string") {
			let raw = payload.trim();
			if (!raw) return null;
			try {
				return JSON.parse(raw);
			} catch (_e) {
				return null;
			}
		}
		if (typeof payload === "object" && !Array.isArray(payload)) return payload;
		return null;
	}

	private setObservableValue(vm: any, key: string, value: any): void {
		if (value === undefined) return;
		let observable = vm ? vm[key] : null;
		if (typeof observable === "function") {
			observable(value);
		}
	}

	private setKeyedListValues(items: any, valuesByKey: any): void {
		if (!Array.isArray(items) || !valuesByKey || typeof valuesByKey !== "object") return;
		for (let item of items) {
			if (!item || item.key == null || typeof item.value !== "function") continue;
			let key = String(this.unwrapObservable(item.key));
			if (valuesByKey[key] === undefined) continue;
			item.value(this.toMoney(valuesByKey[key]));
		}
	}

	private setNamedListValues(items: any, values: any): void {
		if (!Array.isArray(items) || !Array.isArray(values)) return;
		let valuesByName: Record<string, any> = {};
		for (let entry of values) {
			if (!entry || entry.name == null) continue;
			valuesByName[String(entry.name).toLowerCase()] = entry.value;
		}
		for (let i = 0; i < items.length; i++) {
			let item = items[i];
			if (!item || typeof item.value !== "function") continue;
			let label = item.label != null ? String(item.label).toLowerCase() : "";
			if (label && valuesByName[label] !== undefined) {
				item.value(this.toMoney(valuesByName[label]));
				continue;
			}
			if (values[i] && values[i].value !== undefined) {
				item.value(this.toMoney(values[i].value));
			}
		}
	}

	private setSubsistenceAllowanceValues(items: any, values: any): void {
		if (!Array.isArray(items) || !Array.isArray(values)) return;
		let valuesByPaygrade: Record<string, number> = {};
		for (let entry of values) {
			if (!entry || entry.paygrade == null) continue;
			valuesByPaygrade[String(parseInt(entry.paygrade, 10) || 0)] = this.toMoney(entry.value);
		}
		for (let item of items) {
			if (!item || item.label == null || typeof item.value !== "function") continue;
			let paygrade = PAYGRADE_MAP[String(item.label)];
			if (paygrade == null) continue;
			let savedValue = valuesByPaygrade[String(paygrade)];
			if (savedValue === undefined) continue;
			item.value(savedValue);
		}
	}

	public populateFromPayload(payload: any): void {
		let vm = this.vm();
		let data = this.parseSavedPayload(payload);
		if (!vm || !data) return;

		let scalarFields = [
			"payCalculatorYear",
			"bahRateYear",
			"activeDutyPayChartUrl",
			"drillPayPaychartUrl",
			"bahRateWithDependantUrl",
			"bahRateWithoutDependantUrl",
			"imminentDangerPay",
			"hostilePay",
			"demolitionPay",
			"jumpPay",
			"haloPay",
			"flightDeckDutyPay",
			"hazardPayNonCrewmemberPay",
			"singleForeignLanguagePay",
			"multipleForeignLanguagePay",
			"extendedDutySpecialPay",
			"separationPay",
			"assymetricWarfarePay",
			"militaryIntelligencePay",
			"commandSergeantMajorPay",
			"msstTacletLeaderPay",
			"cgDiverPay",
			"rescueSwimmerPay",
			"surfmanPay",
			"masterDiverPay",
			"salvageDiverPay",
			"combatantDiverPay",
			"combatDiverPay",
			"paraRescueDiverPay",
			"combatantSwimmerNavyPay",
			"basicCombatantSwimmerNavyPay",
			"masterUCTDiverNavyPay",
			"advancedUCTDiverNavyPay",
			"basicUCTDiverNavyPay",
			"scubaDiverNavyPay",
			"medicalDivingTechNavyPay",
			"medicalDiverSaturationNavyPay",
			"diverInTrainingNavyPay",
			"saturationDiverNavyPay",
			"sealDeliveryVehiclePilotNavyPay",
			"specialWarfareOperatorNavyPay",
			"medicalSpecialOpsTechNavyPay",
			"specReconFleetCorpsmanNavyPay",
			"medicalDivingOfficerNavyPay",
			"divingCWONavyPay",
			"specialWarfareOfficerNavyPay",
			"eodDiverNavyPay",
			"eodAssistantNavyPay",
			"basicEODTechDiverNavyPay",
			"srEodTechDiverNavyPay",
			"masterEODTechNavyPay",
			"eodOfficerNavyPay",
		];
		for (let key of scalarFields) {
			this.setObservableValue(vm, key, data[key]);
		}

		let specialMissionsPay = data.specialMissionsPay || {};
		this.setObservableValue(vm, "specialMissionsPay1", specialMissionsPay["1"]);
		this.setObservableValue(vm, "specialMissionsPay2", specialMissionsPay["2"]);

		let diverFirstClassPay = data.diverFirstClassPay || {};
		this.setObservableValue(vm, "diverFirstClassPay3", diverFirstClassPay["3"]);
		this.setObservableValue(vm, "diverFirstClassPay4", diverFirstClassPay["4"]);

		let diverSecondClassPay = data.diverSecondClassPay || {};
		this.setObservableValue(vm, "diverSecondClassPay3", diverSecondClassPay["3"]);
		this.setObservableValue(vm, "diverSecondClassPay4", diverSecondClassPay["4"]);

		let divingOfficerPay = data.divingOfficerPay || {};
		this.setObservableValue(vm, "divingOfficerPay2", divingOfficerPay["2"]);
		this.setObservableValue(vm, "divingOfficerPay3", divingOfficerPay["3"]);

		let scubaPay = data.scubaPay || {};
		this.setObservableValue(vm, "scubaPay2", scubaPay["2"]);
		this.setObservableValue(vm, "scubaPay4", scubaPay["4"]);

		this.setKeyedListValues(vm.eodPayList ? vm.eodPayList() : null, data.eodPay);
		this.setKeyedListValues(vm.airForceEnlistedPayList ? vm.airForceEnlistedPayList() : null, data.airForceEnlistedPay);
		this.setKeyedListValues(vm.navyEnlistedPayList ? vm.navyEnlistedPayList() : null, data.navyEnlistedPay);
		this.setKeyedListValues(vm.hazardPayHDIPList ? vm.hazardPayHDIPList() : null, data.hazardPayHDIPCrewMemberPay);

		this.setNamedListValues(vm.aviationExperiencePayList ? vm.aviationExperiencePayList() : null, data.yearsOfAviationExperienceOptions);
		this.setNamedListValues(vm.airForceAviationExperiencePayList ? vm.airForceAviationExperiencePayList() : null, data.yearsOfAirForceAviationExperienceOptions);
		this.setSubsistenceAllowanceValues(vm.substistanceAllowancePayList ? vm.substistanceAllowancePayList() : null, data.substistanceAllowancePay);

		this.setObservableValue(vm, "basePayMatrixData", Array.isArray(data.basePayMatrix) ? data.basePayMatrix : []);
		this.setObservableValue(vm, "housingAllowanceData", data.housingAllowance && typeof data.housingAllowance === "object" ? data.housingAllowance : {});
		this.setObservableValue(vm, "cboZipData", Array.isArray(data.cboZip) ? data.cboZip : []);
		this.setObservableValue(vm, "colaRateWithDependantData", data.colaRateWithDependant && typeof data.colaRateWithDependant === "object" ? data.colaRateWithDependant : {});
		this.setObservableValue(vm, "zipCode2DutyStationData", data.zipCode2DutyStation && typeof data.zipCode2DutyStation === "object" ? data.zipCode2DutyStation : {});
		this.setObservableValue(vm, "colaBasePayWithDepsData", Array.isArray(data.colaBasePayWithDependants) ? data.colaBasePayWithDependants : []);
		this.setObservableValue(vm, "colaBasePayWithoutDepsData", Array.isArray(data.colaBasePayWithoutDependants) ? data.colaBasePayWithoutDependants : []);

		this.setObservableValue(vm, "seaPayMatrixJson", "");
		this.setObservableValue(vm, "submarinePayJson", "");
		this.setObservableValue(vm, "awacsPayJson", "");
		this.setObservableValue(vm, "cboHDPJson", "");
		this.setObservableValue(vm, "cboDivingPayJson", "");

		this.setObservableValue(vm, "seaPayMatrixData", data.seaPayMatrix && typeof data.seaPayMatrix === "object" ? data.seaPayMatrix : {});
		this.setObservableValue(vm, "submarinePayData", Array.isArray(data.submarinePay) ? data.submarinePay : []);
		this.setObservableValue(vm, "awacsPayData", Array.isArray(data.hazardousDutyPayCrewmemberAWACSPay) ? data.hazardousDutyPayCrewmemberAWACSPay : []);
		this.setObservableValue(vm, "cboHDPData", Array.isArray(data.cboHDP) ? data.cboHDP : []);
		this.setObservableValue(vm, "cboDivingPayData", Array.isArray(data.cboDivingPay) ? data.cboDivingPay : []);

		if (typeof vm.hydrateSeaPayMatrixFromJson === "function") vm.hydrateSeaPayMatrixFromJson();
		if (typeof vm.hydrateSubmarinePayFromJson === "function") vm.hydrateSubmarinePayFromJson();
		if (typeof vm.hydrateAwacsPayFromJson === "function") vm.hydrateAwacsPayFromJson();
		if (typeof vm.hydrateCboHDPFromJson === "function") vm.hydrateCboHDPFromJson();
		if (typeof vm.hydrateCboDivingPayFromJson === "function") vm.hydrateCboDivingPayFromJson();

		this.setObservableValue(vm, "generatedJson", null);
		this.setObservableValue(vm, "jsonPreview", "");
	}

	public handleBahRatesUpload(event: any): void {
		let file = event.target.files[0];
		if (!file) return;
		let vm = this.vm();
		let self = this;
		let reader = new FileReader();
		reader.onload = function (e: any) {
			try {
				let workbook = XLSX.read(e.target.result, { type: "array" });
				let housingAllowance: Record<string, number[]> = {};
				let cboZipList: any[] = [];
				let bahColOrder = [
					"E01",
					"E02",
					"E03",
					"E04",
					"E05",
					"E06",
					"E07",
					"E08",
					"E09",
					"W01",
					"W02",
					"W03",
					"W04",
					"W05",
					"O01E",
					"O02E",
					"O03E",
					"O01",
					"O02",
					"O03",
					"O04",
					"O05",
					"O06",
					"O07",
					"O08",
					"O09",
					"O10",
				];
				let bahSheets = [
					{ sheet: workbook.Sheets["With"] || workbook.Sheets[workbook.SheetNames[0]], offset: 0 },
					{ sheet: workbook.Sheets["Without"] || workbook.Sheets[workbook.SheetNames[1]], offset: 27 },
				];
				for (let sheetConfig of bahSheets) {
					let sheet = sheetConfig.sheet;
					if (!sheet) continue;
					let rows: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1 });
					let headerRow = rows[1];
					if (!headerRow) continue;

					// Resolve column index by pay grade from header (supports O-10 first or E-1 first column order)
					let colIndexByPaygrade: Record<number, number> = {};
					let usedHeader = false;
					for (let col = 0; col < (headerRow as any[]).length; col++) {
						let cell = (headerRow as any[])[col];
						if (cell == null) continue;
						let raw = String(cell).trim().toUpperCase().replace(/\s+/g, "");
						let colKey: string | undefined;
						for (let label of Object.keys(BAH_HEADER_TO_COL_KEY)) {
							let norm = label.replace(/-/g, "").toUpperCase();
							if (norm === raw) {
								colKey = BAH_HEADER_TO_COL_KEY[label];
								break;
							}
						}
						if (!colKey && raw.length >= 2) {
							let m = raw.match(/^([OWE])(\d+)(E?)$/);
							if (m) {
								let letter = m[1],
									num = m[2],
									e = m[3] || "";
								if (letter === "E") colKey = "E" + (num.length === 1 ? "0" + num : num);
								else if (letter === "W") colKey = "W" + (num.length === 1 ? "0" + num : num);
								else if (letter === "O") colKey = "O" + (num.length === 1 ? "0" + num : num) + e;
							}
						}
						if (colKey && BAH_COL_TO_PAYGRADE[colKey] !== undefined) {
							colIndexByPaygrade[BAH_COL_TO_PAYGRADE[colKey]] = col;
							usedHeader = true;
						}
					}
					if (!usedHeader) {
						for (let c = 0; c < 27; c++) {
							colIndexByPaygrade[BAH_COL_TO_PAYGRADE[bahColOrder[c]]] = c + 2;
						}
					}

					let offset = sheetConfig.offset;
					for (let r = 2; r < rows.length; r++) {
						let row = rows[r];
						if (!row || !row[0]) continue;
						let mha = String(row[0]).trim();
						let mhaName = row[1] ? String(row[1]).trim() : "";

						if (!housingAllowance[mha]) {
							housingAllowance[mha] = new Array(54).fill(0);
							cboZipList.push({ value: mha, name: mhaName });
						}

						for (let pg = 1; pg <= 27; pg++) {
							let excelCol = colIndexByPaygrade[pg];
							if (excelCol === undefined) continue;
							let val = parseFloat((row as any[])[excelCol]);
							if (isNaN(val)) continue;
							let idx = offset + (pg - 1);
							housingAllowance[mha][idx] = Math.round(val);
						}
					}
				}

				self.backfillHousingAllowanceZeros(housingAllowance);

				vm.housingAllowanceData(housingAllowance);
				vm.cboZipData(cboZipList);
				vm.bahRatesCount(Object.keys(housingAllowance).length);
				vm.cboZipCount(cboZipList.length);
				vm.bahRatesStatus("Parsed");
			} catch (err) {
				alert("Error parsing BAH Rates: " + err.message);
				vm.bahRatesStatus("Error");
			}
		};
		reader.readAsArrayBuffer(file);
	}

	/** Replace 0s in housing allowance with next (or previous) non-zero in same with/without half to fix missing O-10/O-9/O-8 or E-1/E-2/E-3 columns. */
	private backfillHousingAllowanceZeros(housingAllowance: Record<string, number[]>): void {
		for (let mha of Object.keys(housingAllowance)) {
			let arr = housingAllowance[mha];
			for (let half = 0; half < 2; half++) {
				let start = half * 27,
					end = start + 27;
				let nextNonZero = 0;
				for (let i = start; i < end; i++) {
					if (arr[i] !== 0) {
						nextNonZero = arr[i];
						break;
					}
				}
				for (let i = start; i < end; i++) {
					if (arr[i] !== 0) nextNonZero = arr[i];
					else if (nextNonZero > 0) arr[i] = nextNonZero;
				}
				let prevNonZero = 0;
				for (let i = end - 1; i >= start; i--) {
					if (arr[i] !== 0) prevNonZero = arr[i];
					else if (prevNonZero > 0) arr[i] = prevNonZero;
				}
			}
		}
	}

	public handleZipCodeMappingUpload(event: any): void {
		let file = event.target.files[0];
		if (!file) return;
		let vm = this.vm();
		let reader = new FileReader();
		reader.onload = function (e: any) {
			try {
				let text = e.target.result;
				let lines = text.split("\n");
				let mapping: Record<string, string> = {};
				for (let line of lines) {
					line = line.trim();
					if (!line) continue;
					let parts = line.split(/\s+/);
					if (parts.length >= 2) {
						mapping[parts[0]] = parts[1];
					}
				}
				vm.zipCode2DutyStationData(mapping);
				vm.zipCodeMappingCount(Object.keys(mapping).length);
				vm.zipCodeMappingStatus("Parsed");
			} catch (err) {
				alert("Error parsing ZipCode Mapping: " + err.message);
				vm.zipCodeMappingStatus("Error");
			}
		};
		reader.readAsText(file);
	}

	public handleColaZipsUpload(event: any): void {
		let file = event.target.files[0];
		if (!file) return;
		let vm = this.vm();
		let reader = new FileReader();
		reader.onload = function (e: any) {
			try {
				let text = e.target.result;
				let lines = text.split("\n");
				let colaRates: Record<string, number> = {};
				for (let line of lines) {
					line = line.trim();
					if (!line) continue;
					let parts = line.split(";");
					if (parts.length >= 2) {
						colaRates[parts[0].trim()] = parseInt(parts[1].trim()) || 0;
					}
				}
				vm.colaRateWithDependantData(colaRates);
				vm.colaZipsCount(Object.keys(colaRates).length);
				vm.colaZipsStatus("Parsed");
			} catch (err) {
				alert("Error parsing COLA Zips: " + err.message);
				vm.colaZipsStatus("Error");
			}
		};
		reader.readAsText(file);
	}

	/** Parse COLA text: each line = one pay grade (left), semicolon-separated values = years of service (right). Structure matches chart: GRADE × YEARS OF SERVICE. */
	private parseColaText(text: string): any[] {
		let lines = text.split("\n");
		let entries: any[] = [];
		for (let line of lines) {
			line = line.trim();
			if (!line) continue;
			let parts = line.split(";");
			if (parts.length < 2) continue;
			let pgName = parts[0].trim();
			let pgVal = PAYGRADE_MAP[pgName];
			if (pgVal === undefined) continue;
			let values = parts.slice(1).map(function (v: string) {
				return parseInt(v.trim()) || 0;
			});
			let mappedValues: number[] = [];
			for (let idx of COLA_COL_INDICES) {
				mappedValues.push(idx < values.length ? values[idx] : 0);
			}
			for (let yos = 0; yos < mappedValues.length; yos++) {
				entries.push({
					value: mappedValues[yos],
					paygrade: pgVal,
					yearsOfService: yos + 1,
				});
			}
		}
		return entries;
	}

	public handleColaWithDepsUpload(event: any): void {
		let file = event.target.files[0];
		if (!file) return;
		let vm = this.vm();
		let self = this;
		let reader = new FileReader();
		reader.onload = function (e: any) {
			try {
				let entries = self.parseColaText(e.target.result);
				vm.colaBasePayWithDepsData(entries);
				vm.colaWithDepsCount(entries.length);
				vm.colaWithDepsStatus("Parsed");
			} catch (err) {
				alert("Error parsing COLA With Dependents: " + err.message);
				vm.colaWithDepsStatus("Error");
			}
		};
		reader.readAsText(file);
	}

	public handleColaWithoutDepsUpload(event: any): void {
		let file = event.target.files[0];
		if (!file) return;
		let vm = this.vm();
		let self = this;
		let reader = new FileReader();
		reader.onload = function (e: any) {
			try {
				let entries = self.parseColaText(e.target.result);
				vm.colaBasePayWithoutDepsData(entries);
				vm.colaWithoutDepsCount(entries.length);
				vm.colaWithoutDepsStatus("Parsed");
			} catch (err) {
				alert("Error parsing COLA Without Dependents: " + err.message);
				vm.colaWithoutDepsStatus("Error");
			}
		};
		reader.readAsText(file);
	}

	private parsePayMatrix(workbook: any, isDrillPay: boolean): any[] {
		let sheet = workbook.Sheets[workbook.SheetNames[0]];
		let rows: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

		let headerRowIdx = -1;
		for (let i = 0; i < rows.length; i++) {
			if (rows[i] && rows[i][0] && String(rows[i][0]).trim().toLowerCase().indexOf("pay grade") >= 0) {
				headerRowIdx = i;
				break;
			}
		}
		if (headerRowIdx < 0) throw new Error('Could not find header row with "Pay Grade"');

		let entries: any[] = [];
		for (let r = headerRowIdx + 1; r < rows.length; r++) {
			let row = rows[r];
			if (!row || !row[0]) continue;
			let pgName = String(row[0]).trim();
			let pgVal = PAYGRADE_MAP[pgName];
			if (pgVal === undefined) continue;

			for (let c = 1; c < row.length; c++) {
				let yos = c;
				if (yos > 18) break;
				let val = this.toMoney(row[c]);
				if (isDrillPay) {
					entries.push({ paygrade: pgVal, yearsOfService: yos, drillPay4Month: val });
				} else {
					entries.push({
						value: val,
						paygrade: pgVal,
						yearsOfService: yos,
					});
				}
			}
		}
		return entries;
	}

	public handleActiveDutyPayUpload(event: any): void {
		let file = event.target.files[0];
		if (!file) return;
		let vm = this.vm();
		let self = this;
		let reader = new FileReader();
		reader.onload = function (e: any) {
			try {
				let workbook = XLSX.read(e.target.result, { type: "array" });
				let entries = self.parsePayMatrix(workbook, false);
				vm.basePayMatrixData(entries);
				vm.activeDutyPayCount(entries.length);
				vm.activeDutyPayStatus("Parsed");
			} catch (err) {
				alert("Error parsing Active Duty Pay: " + err.message);
				vm.activeDutyPayStatus("Error");
			}
		};
		reader.readAsArrayBuffer(file);
	}

	public handleDrillPayUpload(event: any): void {
		let file = event.target.files[0];
		if (!file) return;
		let vm = this.vm();
		let self = this;
		let reader = new FileReader();
		reader.onload = function (e: any) {
			try {
				let workbook = XLSX.read(e.target.result, { type: "array" });
				let drillEntries = self.parsePayMatrix(workbook, true);

				let baseMatrix = vm.basePayMatrixData();
				if (baseMatrix) {
					for (let de of drillEntries) {
						for (let be of baseMatrix) {
							if (be.paygrade === de.paygrade && be.yearsOfService === de.yearsOfService) {
								be.drillPay4Month = de.drillPay4Month;
								break;
							}
						}
					}
					vm.basePayMatrixData(baseMatrix);
				}

				vm.drillPayCount(drillEntries.length);
				vm.drillPayStatus("Parsed");
			} catch (err) {
				alert("Error parsing Drill Pay: " + err.message);
				vm.drillPayStatus("Error");
			}
		};
		reader.readAsArrayBuffer(file);
	}

	// ==================== JSON GENERATION ====================

	public generateJson(): void {
		let vm = this.vm();

		let substistancePay: any[] = [{ value: 0, paygrade: 0 }];
		let basList = vm.substistanceAllowancePayList();
		for (let i = 0; i < basList.length; i++) {
			let pgName = PAYGRADE_NAMES[i];
			let pgVal = PAYGRADE_MAP[pgName];
			substistancePay.push({
				value: this.toMoney(basList[i].value()),
				paygrade: pgVal,
			});
		}

		let eodPay = this.buildKeyedAmountMap(vm.eodPayList());
		let afPay = this.buildKeyedAmountMap(vm.airForceEnlistedPayList());
		let aviationExperienceOptions = this.buildAmountNameValueList(vm.aviationExperiencePayList());
		let airForceAviationExperienceOptions = this.buildAmountNameValueList(vm.airForceAviationExperiencePayList());
		let nvPay = this.buildKeyedAmountMap(vm.navyEnlistedPayList());
		let hdipPay = this.buildKeyedAmountMap(vm.hazardPayHDIPList());

		let housingAllowanceOut: Record<string, number[]> = vm.housingAllowanceData() || {};
		if (Object.keys(housingAllowanceOut).length > 0) {
			let copy: Record<string, number[]> = {};
			for (let k of Object.keys(housingAllowanceOut)) {
				copy[k] = (housingAllowanceOut[k] || []).slice();
			}
			this.backfillHousingAllowanceZeros(copy);
			housingAllowanceOut = copy;
		}

		function parseManualJson<T>(raw: string, fallback: T): T {
			if (!raw || typeof raw !== "string") return fallback;
			let s = raw.trim();
			if (!s) return fallback;
			try {
				let parsed = JSON.parse(s);
				return parsed != null ? parsed : fallback;
			} catch (_e) {
				return fallback;
			}
		}
		let seaPayMatrixOut: Record<string, any> = {};
		if (vm.serializeSeaPayMatrixFromEditor && typeof vm.serializeSeaPayMatrixFromEditor === "function") {
			seaPayMatrixOut = vm.serializeSeaPayMatrixFromEditor();
		} else {
			seaPayMatrixOut = parseManualJson(vm.seaPayMatrixJson(), vm.seaPayMatrixData() || {});
			if (typeof seaPayMatrixOut !== "object" || Array.isArray(seaPayMatrixOut)) seaPayMatrixOut = {};
		}
		let submarinePayOut: any[] = [];
		if (vm.serializeSubmarinePayFromEditor && typeof vm.serializeSubmarinePayFromEditor === "function") {
			submarinePayOut = vm.serializeSubmarinePayFromEditor();
		} else {
			submarinePayOut = parseManualJson(vm.submarinePayJson(), vm.submarinePayData() || []);
			if (!Array.isArray(submarinePayOut)) submarinePayOut = [];
		}
		let awacsPayOut: any[] = [];
		if (vm.serializeAwacsPayFromEditor && typeof vm.serializeAwacsPayFromEditor === "function") {
			awacsPayOut = vm.serializeAwacsPayFromEditor();
		} else {
			awacsPayOut = parseManualJson(vm.awacsPayJson(), vm.awacsPayData() || []);
			if (!Array.isArray(awacsPayOut)) awacsPayOut = [];
		}
		let cboHDPOut: any[] = [];
		if (vm.serializeCboHDPFromEditor && typeof vm.serializeCboHDPFromEditor === "function") {
			cboHDPOut = vm.serializeCboHDPFromEditor();
		} else {
			cboHDPOut = parseManualJson(vm.cboHDPJson(), vm.cboHDPData() || []);
			if (!Array.isArray(cboHDPOut)) cboHDPOut = [];
		}
		let cboDivingPayOut: any[] = [];
		if (vm.serializeCboDivingPayFromEditor && typeof vm.serializeCboDivingPayFromEditor === "function") {
			cboDivingPayOut = vm.serializeCboDivingPayFromEditor();
		} else {
			cboDivingPayOut = parseManualJson(vm.cboDivingPayJson(), vm.cboDivingPayData() || []);
			if (!Array.isArray(cboDivingPayOut)) cboDivingPayOut = [];
		}

		let output: any = {
			id: null,
			basicPayStatus: this.cloneNameValueList(BASIC_PAY_STATUS_OPTIONS),
			cboZip: this.normalizeStringNameValueList(vm.cboZipData()),
			cboHDP: cboHDPOut,
			cboDivingPay: cboDivingPayOut,
			yearsOfSeaDuty: this.cloneNameValueList(YEARS_OF_SEA_DUTY_OPTIONS),
			yearsOfSubmarineExperience: this.cloneNameValueList(YEARS_OF_SUBMARINE_EXPERIENCE_OPTIONS),
			dependants: this.cloneNameValueList(DEPENDANTS_OPTIONS),
			yearsOfService: this.cloneNameValueList(YEARS_OF_SERVICE_OPTIONS),
			branches: this.cloneNameValueList(BRANCH_OPTIONS),
			paygrades: this.cloneNameValueList(PAYGRADE_OPTIONS),
			basePayMatrix: this.normalizeBasePayEntries(vm.basePayMatrixData()),
			seaPayMatrix: seaPayMatrixOut,
			singleForeignLanguagePay: this.toMoney(vm.singleForeignLanguagePay()),
			multipleForeignLanguagePay: this.toMoney(vm.multipleForeignLanguagePay()),
			extendedDutySpecialPay: this.toMoney(vm.extendedDutySpecialPay()),
			demolitionPay: this.toMoney(vm.demolitionPay()),
			imminentDangerPay: this.toMoney(vm.imminentDangerPay()),
			hostilePay: this.toMoney(vm.hostilePay()),
			separationPay: this.toMoney(vm.separationPay()),
			jumpPay: this.toMoney(vm.jumpPay()),
			hazardPayNonCrewmemberPay: this.toMoney(vm.hazardPayNonCrewmemberPay()),
			haloPay: this.toMoney(vm.haloPay()),
			flightDeckDutyPay: this.toMoney(vm.flightDeckDutyPay()),
			assymetricWarfarePay: this.toMoney(vm.assymetricWarfarePay()),
			militaryIntelligencePay: this.toMoney(vm.militaryIntelligencePay()),
			commandSergeantMajorPay: this.toMoney(vm.commandSergeantMajorPay()),
			masterDiverPay: this.toMoney(vm.masterDiverPay()),
			diverFirstClassPay: { "3": this.toMoney(vm.diverFirstClassPay3()), "4": this.toMoney(vm.diverFirstClassPay4()) },
			diverSecondClassPay: { "3": this.toMoney(vm.diverSecondClassPay3()), "4": this.toMoney(vm.diverSecondClassPay4()) },
			salvageDiverPay: this.toMoney(vm.salvageDiverPay()),
			combatantDiverPay: this.toMoney(vm.combatantDiverPay()),
			combatDiverPay: this.toMoney(vm.combatDiverPay()),
			paraRescueDiverPay: this.toMoney(vm.paraRescueDiverPay()),
			combatantSwimmerNavyPay: this.toMoney(vm.combatantSwimmerNavyPay()),
			basicCombatantSwimmerNavyPay: this.toMoney(vm.basicCombatantSwimmerNavyPay()),
			masterUCTDiverNavyPay: this.toMoney(vm.masterUCTDiverNavyPay()),
			advancedUCTDiverNavyPay: this.toMoney(vm.advancedUCTDiverNavyPay()),
			basicUCTDiverNavyPay: this.toMoney(vm.basicUCTDiverNavyPay()),
			scubaDiverNavyPay: this.toMoney(vm.scubaDiverNavyPay()),
			medicalDivingTechNavyPay: this.toMoney(vm.medicalDivingTechNavyPay()),
			medicalDiverSaturationNavyPay: this.toMoney(vm.medicalDiverSaturationNavyPay()),
			diverInTrainingNavyPay: this.toMoney(vm.diverInTrainingNavyPay()),
			saturationDiverNavyPay: this.toMoney(vm.saturationDiverNavyPay()),
			sealDeliveryVehiclePilotNavyPay: this.toMoney(vm.sealDeliveryVehiclePilotNavyPay()),
			specialWarfareOperatorNavyPay: this.toMoney(vm.specialWarfareOperatorNavyPay()),
			medicalSpecialOpsTechNavyPay: this.toMoney(vm.medicalSpecialOpsTechNavyPay()),
			specReconFleetCorpsmanNavyPay: this.toMoney(vm.specReconFleetCorpsmanNavyPay()),
			eodDiverNavyPay: this.toMoney(vm.eodDiverNavyPay()),
			eodAssistantNavyPay: this.toMoney(vm.eodAssistantNavyPay()),
			basicEODTechDiverNavyPay: this.toMoney(vm.basicEODTechDiverNavyPay()),
			srEodTechDiverNavyPay: this.toMoney(vm.srEodTechDiverNavyPay()),
			masterEODTechNavyPay: this.toMoney(vm.masterEODTechNavyPay()),
			eodOfficerNavyPay: this.toMoney(vm.eodOfficerNavyPay()),
			specialWarfareOfficerNavyPay: this.toMoney(vm.specialWarfareOfficerNavyPay()),
			medicalDivingOfficerNavyPay: this.toMoney(vm.medicalDivingOfficerNavyPay()),
			divingCWONavyPay: this.toMoney(vm.divingCWONavyPay()),
			msstTacletLeaderPay: this.toMoney(vm.msstTacletLeaderPay()),
			cgDiverPay: this.toMoney(vm.cgDiverPay()),
			rescueSwimmerPay: this.toMoney(vm.rescueSwimmerPay()),
			surfmanPay: this.toMoney(vm.surfmanPay()),
			hazardousDutyPayCrewmemberAWACSPay: awacsPayOut,
			hazardPayHDIPCrewMemberPay: hdipPay,
			divingOfficerPay: { "2": this.toMoney(vm.divingOfficerPay2()), "3": this.toMoney(vm.divingOfficerPay3()) },
			scubaPay: { "2": this.toMoney(vm.scubaPay2()), "4": this.toMoney(vm.scubaPay4()) },
			eodPay: eodPay,
			substistanceAllowancePay: substistancePay,
			submarinePay: submarinePayOut,
			housingAllowance: housingAllowanceOut,
			yearsOfAirForceAviationExperienceOptions: airForceAviationExperienceOptions,
			yearsOfAviationExperienceOptions: aviationExperienceOptions,
			yearsOfHazardousDutyPayCrewmemberAWACS: this.cloneNameValueList(YEARS_OF_HAZARDOUS_DUTY_AWACS_OPTIONS),
			airForceEnlistedFlyersOptions: this.cloneNameValueList(AIR_FORCE_ENLISTED_FLYERS_OPTIONS),
			navyEnlistedFlyersOptions: this.cloneNameValueList(NAVY_ENLISTED_FLYERS_OPTIONS),
			airForceEnlistedPay: afPay,
			navyEnlistedPay: nvPay,
			colaRateWithDependant: vm.colaRateWithDependantData() || {},
			zipCode2DutyStation: vm.zipCode2DutyStationData() || {},
			colaBasePayWithoutDependants: this.normalizePaygradeYearValueList(vm.colaBasePayWithoutDepsData()),
			colaBasePayWithDependants: this.normalizePaygradeYearValueList(vm.colaBasePayWithDepsData()),
			yearsOfSpecialMissionsOptions: this.cloneNameValueList(YEARS_OF_SPECIAL_MISSIONS_OPTIONS),
			specialMissionsPay: {
				"1": this.toMoney(vm.specialMissionsPay1()),
				"2": this.toMoney(vm.specialMissionsPay2()),
			},
			bahRateWithoutDependantUrl: vm.bahRateWithoutDependantUrl() || "",
			bahRateWithDependantUrl: vm.bahRateWithDependantUrl() || "",
			activeDutyPayChartUrl: vm.activeDutyPayChartUrl() || "",
			drillPayPaychartUrl: vm.drillPayPaychartUrl() || "",
			payCalculatorYear: parseInt(vm.payCalculatorYear()) || new Date().getFullYear(),
			bahRateYear: parseInt(vm.bahRateYear()) || new Date().getFullYear(),
		};

		vm.generatedJson(output);
		let preview = JSON.stringify(output, null, 2);
		if (preview.length > 50000) {
			vm.jsonPreview(preview.substring(0, 50000) + "\n\n... (truncated for preview, full file will be downloaded)");
		} else {
			vm.jsonPreview(preview);
		}
	}

	public downloadJson(): void {
		let vm = this.vm();
		let json = vm.generatedJson();
		if (!json) return;

		let blob = new Blob([JSON.stringify(json, null, 2)], { type: "application/json" });
		let url = URL.createObjectURL(blob);
		let a = document.createElement("a");
		a.href = url;
		a.download = "paycalculator.json";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	}

	public save(): void {
		let vm = this.vm();
		let json = vm.generatedJson();
		if (!json) {
			this.generateJson();
			json = vm.generatedJson();
		}
		if (!json) return;
		if (this.caller && typeof this.caller.save === "function") {
			this.caller.save(json);
		} else {
			vm.saveStatus("Error: module not available");
		}
	}
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryPayCalculator_template.ts